/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: bigint; output: bigint; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: any; output: any; }
  /** Represents date values */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date | string; output: string; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** The `File` scalar type represents a file upload. */
  File: { input: unknown; output: unknown; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  MutationInputDeleteApiV1BokunApiBookingInputConfirmationCode: { input: string; output: string; }
  MutationInputDeleteApiV1BokunApiBookingTransportInputSessionId: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingConfirmInputSessionId: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingInputBookingId: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingInputFirstName: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingInputLastName: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingInputSessionId: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingTransportBackInputSessionId: { input: string; output: string; }
  MutationInputPostApiV1BokunApiBookingTransportForthInputSessionId: { input: string; output: string; }
  MutationInputPutApiV1BokunApiBookingInputConfirmationCode: { input: string; output: string; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: string; output: string; }
  ObjMap: { input: Record<string, any>; output: Record<string, any>; }
  QueryInputApiV1BokunApiBookingSessionInputSessionId: { input: string; output: string; }
  QueryInputApiV1SkincareShopProductsByIdId: { input: string; output: string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  /** Represents empty values */
  Void: { input: void; output: void; }
};

export type AcsInfo = {
  __typename?: 'AcsInfo';
  acsForm?: Maybe<Scalars['String']['output']>;
  acsFormData?: Maybe<Array<Maybe<BorgunPaymentModelMpiEnrollmentResponseAcsField>>>;
};

export type ActivityCartActivityCartCheckoutResponse = {
  __typename?: 'ActivityCartActivityCartCheckoutResponse';
  bookingNumber?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartActivityCartCustomerModel = {
  __typename?: 'ActivityCartActivityCartCustomerModel';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartActivityCartDataModel = {
  __typename?: 'ActivityCartActivityCartDataModel';
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<ActivityCartActivityCartCustomerModel>;
  discountedAmount?: Maybe<Scalars['Float']['output']>;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  expirationLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  giftCardPaymentAmount?: Maybe<Scalars['Float']['output']>;
  giftCards?: Maybe<Array<Maybe<ActivityCartActivityGiftCardModel>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ActivityCartActivityCartItemDataModel>>>;
  membership?: Maybe<ActivityCartDtoMembershipInfo>;
  originalItems?: Maybe<Array<Maybe<ActivityCartActivityCartItemDataModel>>>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentRequired?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  validationIssues?: Maybe<Array<Maybe<ActivityCartDtoValidationIssue>>>;
};

export type ActivityCartActivityCartItemDataModel = {
  __typename?: 'ActivityCartActivityCartItemDataModel';
  discountedPrice?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fixedDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  linePrice?: Maybe<Scalars['Float']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reservationStatus?: Maybe<Scalars['String']['output']>;
  totalLinePrice?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartActivityCartPingCheckoutResponse = {
  __typename?: 'ActivityCartActivityCartPingCheckoutResponse';
  bookingRef?: Maybe<Scalars['String']['output']>;
  bookingSuccesful?: Maybe<Scalars['Boolean']['output']>;
  busTransferSuccessful?: Maybe<Scalars['Boolean']['output']>;
  confirmSuccessful?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  finished?: Maybe<Scalars['DateTime']['output']>;
  inProgress?: Maybe<Scalars['Boolean']['output']>;
  orderSuccessful?: Maybe<Scalars['Boolean']['output']>;
  paymentSuccessful?: Maybe<Scalars['Boolean']['output']>;
  retailItemsAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityCartActivityCartStoreCustomerResponse = {
  __typename?: 'ActivityCartActivityCartStoreCustomerResponse';
  cart?: Maybe<ActivityCartActivityCartDataModel>;
};

export type ActivityCartActivityCartTransactionResponse = {
  __typename?: 'ActivityCartActivityCartTransactionResponse';
  _error?: Maybe<ErrorObject>;
  cart?: Maybe<ActivityCartActivityCartDataModel>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartActivityGiftCardModel = {
  __typename?: 'ActivityCartActivityGiftCardModel';
  balance?: Maybe<Scalars['Float']['output']>;
  chargeAmount?: Maybe<Scalars['Float']['output']>;
  no?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartDtoMembershipInfo = {
  __typename?: 'ActivityCartDtoMembershipInfo';
  membershipToken?: Maybe<Scalars['String']['output']>;
  numberOfCardHolders?: Maybe<Scalars['Int']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartDtoValidationIssue = {
  __typename?: 'ActivityCartDtoValidationIssue';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartGetProductAvailabilityResponse = {
  __typename?: 'ActivityCartGetProductAvailabilityResponse';
  offer?: Maybe<Array<Maybe<ActivityCartProductOfferData>>>;
};

export type ActivityCartProductOfferData = {
  __typename?: 'ActivityCartProductOfferData';
  available?: Maybe<Scalars['Int']['output']>;
  componentId?: Maybe<Scalars['String']['output']>;
  componentType?: Maybe<Scalars['String']['output']>;
  expire?: Maybe<Scalars['Float']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  subOffers?: Maybe<Array<Maybe<ActivityCartProductSubOfferData>>>;
  time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActivityCartProductSubOfferData = {
  __typename?: 'ActivityCartProductSubOfferData';
  additionalInfo?: Maybe<Scalars['JSON']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  subIdType?: Maybe<Scalars['String']['output']>;
};

export type AddBookingItemRequestModelInput = {
  bookingId?: InputMaybe<Scalars['UUID']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['NonEmptyString']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddBookingItemsRequestModelInput = {
  items?: InputMaybe<Array<InputMaybe<AddBookingItemRequestModelInput>>>;
  salesLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type AgentBookingActivityData = {
  __typename?: 'AgentBookingActivityData';
  bookingId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reservationDate?: Maybe<Scalars['DateTime']['output']>;
  reservationTime?: Maybe<Scalars['DateTime']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type AgentBookingAddedProductData = {
  __typename?: 'AgentBookingAddedProductData';
  bookingRef?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type AgentBookingBookingInfoData = {
  __typename?: 'AgentBookingBookingInfoData';
  activities?: Maybe<Array<Maybe<AgentBookingActivityData>>>;
  adultCount?: Maybe<Scalars['Int']['output']>;
  adultPrice?: Maybe<Scalars['Float']['output']>;
  agentBookingRef?: Maybe<Scalars['String']['output']>;
  agentInitials?: Maybe<Scalars['String']['output']>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  arrivalTime?: Maybe<Scalars['DateTime']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['String']['output']>;
  busTransfer?: Maybe<AgentBookingBusTransferData>;
  childrenCount?: Maybe<Scalars['Int']['output']>;
  childrenPrice?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<AgentBookingCustomerData>;
  generalBusTransfer?: Maybe<BookingDtoIBusTransferData>;
  generalCustomer?: Maybe<BookingDtoICustomerData>;
  generalMassage?: Maybe<Array<Maybe<BookingDtoIMassageData>>>;
  generalTableReservation?: Maybe<BookingDtoITableReservationData>;
  massage?: Maybe<Array<Maybe<AgentBookingMassageData>>>;
  packageType?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<AgentBookingAddedProductData>>>;
  promoCode?: Maybe<Scalars['String']['output']>;
  tableReservation?: Maybe<AgentBookingTableReservationData>;
  teenagerCount?: Maybe<Scalars['Int']['output']>;
  teenagerPrice?: Maybe<Scalars['Float']['output']>;
  timeFrom?: Maybe<Scalars['String']['output']>;
  timeTo?: Maybe<Scalars['String']['output']>;
};

export type AgentBookingBusTransferData = {
  __typename?: 'AgentBookingBusTransferData';
  adultPrice?: Maybe<Scalars['Int']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  departureTime?: Maybe<Scalars['DateTime']['output']>;
  dropoffLocationId?: Maybe<Scalars['String']['output']>;
  dropoffLocationName?: Maybe<Scalars['String']['output']>;
  pickupLocationId?: Maybe<Scalars['String']['output']>;
  pickupLocationName?: Maybe<Scalars['String']['output']>;
  pickupTime?: Maybe<Scalars['String']['output']>;
};

export type AgentBookingCustomerData = {
  __typename?: 'AgentBookingCustomerData';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type AgentBookingMassageData = {
  __typename?: 'AgentBookingMassageData';
  guests?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type AgentBookingTableReservationData = {
  __typename?: 'AgentBookingTableReservationData';
  arrivalTime?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  guests?: Maybe<Scalars['Int']['output']>;
};

export type ApiV1PaymentAliasByAliasResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetGetAliasInformationResponse;

export type ApiV1PaymentCurrencyRatesResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetCollectCurrencyConversionRatesResponse;

export type ApiV1PaymentMulticurrencyRatesResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetCollectCurrencyConversionRatesResponse;

export type ApiV1PaymentTransactionAliasByTransactionIdResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetGetAliasResponse;

export type ApiV1PaymentTransactionPaybylinkByRefnoByAmountByDuedateResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetPayByLinkResponse;

export type ApiV1PaymentTransactionStatusBySearchResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetGetPaymentStatusResponse;

export type BcActivityLine = {
  __typename?: 'BcActivityLine';
  bookingRef?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lineNo?: Maybe<Scalars['String']['output']>;
  numberOfAdults?: Maybe<Scalars['Int']['output']>;
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  numberOfPersons?: Maybe<Scalars['Int']['output']>;
  productNo?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reservationDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subStatus?: Maybe<Scalars['String']['output']>;
};

export type BcSetFastCheckinRequestInput = {
  bookingNo?: InputMaybe<Scalars['String']['input']>;
};

export type BlBookingApiDataRefundPolicy = {
  __typename?: 'BlBookingApiDataRefundPolicy';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refundPolicyLines?: Maybe<Array<Maybe<BlBookingApiDataRefundPolicyLine>>>;
  retreat?: Maybe<Scalars['Boolean']['output']>;
  storm?: Maybe<Scalars['Boolean']['output']>;
};

export type BlBookingApiDataRefundPolicyLine = {
  __typename?: 'BlBookingApiDataRefundPolicyLine';
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refundPercentage?: Maybe<Scalars['Float']['output']>;
  refundPolicy?: Maybe<BlBookingApiDataRefundPolicy>;
  refundPolicyId?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type BlBookingApiSecurityModelsJwtTokenResult = {
  __typename?: 'BlBookingApiSecurityModelsJwtTokenResult';
  _error?: Maybe<ErrorObject>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type BlBookingApiSecurityModelsMyBookingLoginInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type BlBookingApiSecurityModelsRefreshTokenDataInput = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type BlInternalApiFunctionsConfigurationSetStaffTicketConfigRequestInput = {
  availableTickets?: InputMaybe<Scalars['Int']['input']>;
  availableTicketsChildrenPerAdult?: InputMaybe<Scalars['Int']['input']>;
  availableTicketsDaily?: InputMaybe<Scalars['Int']['input']>;
  availableTicketsMaxPerBooking?: InputMaybe<Scalars['Int']['input']>;
};

export enum BlLsRetailODataActivityServiceEnumsActivityStatus {
  Cancelled = 'CANCELLED',
  CancelNoFee = 'CANCEL_NO_FEE',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  Confirmed = 'CONFIRMED',
  DiningCheckOut = 'DINING_CHECK_OUT',
  EditDraft = 'EDIT_DRAFT',
  NoShow = 'NO_SHOW',
  UnconfirmedWeb = 'UNCONFIRMED_WEB',
  Upgraded = 'UPGRADED',
  WaitingOnApproval = 'WAITING_ON_APPROVAL'
}

export type BlLsRetailODataBlcpModelBlcpAccountContact = {
  __typename?: 'BlLsRetailODataBlcpModelBlcpAccountContact';
  accountContactId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type BlLsRetailODataBlcpModelCpAttributePair = {
  __typename?: 'BlLsRetailODataBlcpModelCpAttributePair';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum BlLsRetailODataPlanetEnumsPaymentChannel {
  AgentWeb = 'AgentWeb',
  BlTravel = 'BLTravel',
  BookingFlow = 'BookingFlow',
  GiftCard = 'GiftCard',
  Kerlingarfjoll = 'KERLINGARFJOLL',
  Ls = 'LS',
  Membership = 'Membership',
  MyBooking = 'MyBooking',
  None = 'None',
  PayByLink = 'PayByLink',
  Retreat = 'RETREAT',
  Silica = 'SILICA',
  SalesApp = 'SalesApp'
}

export enum BlLsRetailODataPlanetEnumsTransactionBusinessProcess {
  BookingFlow = 'BookingFlow',
  CancelBooking = 'CancelBooking',
  CreateBooking = 'CreateBooking',
  Generic = 'Generic',
  GiftCard = 'GiftCard',
  HighlandToken = 'HighlandToken',
  HotelBookingCart = 'HotelBookingCart',
  RetreatToken = 'RetreatToken',
  SilicaToken = 'SilicaToken',
  SpaBookingCart = 'SpaBookingCart',
  UpdateBooking = 'UpdateBooking'
}

export type BlcpAddPreferencesRequestInput = {
  arrivalTime?: InputMaybe<Scalars['String']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Array<InputMaybe<BlcpBlcpRoomInput>>>;
};

export type BlcpAddPreferencesResponse = {
  __typename?: 'BlcpAddPreferencesResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BlcpBlcpRoomInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  guests?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type BlcpGetPreferencesResponse = {
  __typename?: 'BlcpGetPreferencesResponse';
  accountContact?: Maybe<BlLsRetailODataBlcpModelBlcpAccountContact>;
  arrivalTime?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<BlLsRetailODataBlcpModelCpAttributePair>>>;
  departureTime?: Maybe<Scalars['String']['output']>;
};

export type BluelagoonMutation = {
  __typename?: 'BluelagoonMutation';
  Booking: BookingMutation;
};

export type BluelagoonQuery = {
  __typename?: 'BluelagoonQuery';
  Booking: BookingQuery;
};

export type BokunAddTransportBackRouteModelInput = {
  adults: Scalars['Int']['input'];
  children?: InputMaybe<Scalars['Int']['input']>;
  dropoffDateTime: Scalars['DateTime']['input'];
  dropoffLocationId: Scalars['Int']['input'];
  pickupDateTime: Scalars['DateTime']['input'];
  sessionId: Scalars['MutationInputPostApiV1BokunApiBookingTransportBackInputSessionId']['input'];
};

export type BokunAddTransportForthRouteModelInput = {
  adults: Scalars['Int']['input'];
  children?: InputMaybe<Scalars['Int']['input']>;
  pickupDateTime: Scalars['DateTime']['input'];
  pickupLocationId: Scalars['Int']['input'];
  sessionId: Scalars['MutationInputPostApiV1BokunApiBookingTransportForthInputSessionId']['input'];
};

export type BokunCancelBookingModelInput = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  confirmationCode: Scalars['MutationInputDeleteApiV1BokunApiBookingInputConfirmationCode']['input'];
};

export type BokunConfirmBookingModelInput = {
  paymentId: Scalars['NonEmptyString']['input'];
  sessionId: Scalars['MutationInputPostApiV1BokunApiBookingConfirmInputSessionId']['input'];
};

export type BokunCreateBookingModelInput = {
  bookingId?: InputMaybe<Scalars['MutationInputPostApiV1BokunApiBookingInputBookingId']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['MutationInputPostApiV1BokunApiBookingInputFirstName']['input'];
  lastName: Scalars['MutationInputPostApiV1BokunApiBookingInputLastName']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['MutationInputPostApiV1BokunApiBookingInputSessionId']['input'];
};

export type BokunGetActivityModelInput = {
  activityId: Scalars['BigInt']['input'];
};

export type BokunGetAvailabilityModelInput = {
  activityId: Scalars['BigInt']['input'];
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type BokunGetBookingSessionModelInput = {
  sessionId: Scalars['QueryInputApiV1BokunApiBookingSessionInputSessionId']['input'];
};

export type BokunRemoveTransportRouteModelInput = {
  direction: Scalars['NonEmptyString']['input'];
  locationId: Scalars['BigInt']['input'];
  sessionId: Scalars['MutationInputDeleteApiV1BokunApiBookingTransportInputSessionId']['input'];
};

export type BokunUpdateBookingModelInput = {
  confirmationCode: Scalars['MutationInputPutApiV1BokunApiBookingInputConfirmationCode']['input'];
  transport?: InputMaybe<BokunUpdateTransportModelInput>;
};

export type BokunUpdateTransportModelInput = {
  dropoffDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  pickupDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingByIdResponse = GroupBookingResponseModel | ProblemDetails;

export type BookingCancelBookingResponse = {
  __typename?: 'BookingCancelBookingResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type BookingCustomerRequestModelInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupBookingId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BookingCustomerSingleBookingRequestModelInput = {
  bookingId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BookingDtoIBusTransferData = {
  __typename?: 'BookingDtoIBusTransferData';
  adultPrice?: Maybe<Scalars['Int']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  departureTime?: Maybe<Scalars['DateTime']['output']>;
  dropoffLocationId?: Maybe<Scalars['String']['output']>;
  pickupLocationId?: Maybe<Scalars['String']['output']>;
  pickupTime?: Maybe<Scalars['String']['output']>;
};

export type BookingDtoICustomerData = {
  __typename?: 'BookingDtoICustomerData';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type BookingDtoIMassageData = {
  __typename?: 'BookingDtoIMassageData';
  guests?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type BookingDtoITableReservationData = {
  __typename?: 'BookingDtoITableReservationData';
  arrivalTime?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  guests?: Maybe<Scalars['Int']['output']>;
};

export type BookingFlowCartAddGiftCardRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  giftCard?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartAddItemRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  hotelBookingRef?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingFlowCartAddMembershipTokenRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  membershipToken?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartAddPromoCodeRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartBookingFlowCartCheckoutResponse = {
  __typename?: 'BookingFlowCartBookingFlowCartCheckoutResponse';
  _error?: Maybe<ErrorObject>;
  bookingNumber?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartBookingFlowCartPingCheckoutResponse = {
  __typename?: 'BookingFlowCartBookingFlowCartPingCheckoutResponse';
  bookingRef?: Maybe<Scalars['String']['output']>;
  bookingSuccesful?: Maybe<Scalars['Boolean']['output']>;
  busTransferSuccessful?: Maybe<Scalars['Boolean']['output']>;
  confirmSuccessful?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  finished?: Maybe<Scalars['DateTime']['output']>;
  inProgress?: Maybe<Scalars['Boolean']['output']>;
  orderSuccessful?: Maybe<Scalars['Boolean']['output']>;
  paymentSuccessful?: Maybe<Scalars['Boolean']['output']>;
  retailItemsAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type BookingFlowCartBookingFlowCartStoreCustomerResponse = {
  __typename?: 'BookingFlowCartBookingFlowCartStoreCustomerResponse';
  cart?: Maybe<BookingFlowCartSpaCartDataModel>;
};

export type BookingFlowCartBookingFlowCartTransactionResponse = {
  __typename?: 'BookingFlowCartBookingFlowCartTransactionResponse';
  _error?: Maybe<ErrorObject>;
  cart?: Maybe<BookingFlowCartSpaCartDataModel>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartConfirmModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  customer?: InputMaybe<BookingFlowCustomerModelInput>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartDtoMembershipInfo = {
  __typename?: 'BookingFlowCartDtoMembershipInfo';
  membershipToken?: Maybe<Scalars['String']['output']>;
  numberOfCardHolders?: Maybe<Scalars['Int']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartDtoValidationIssue = {
  __typename?: 'BookingFlowCartDtoValidationIssue';
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartGetProductAvailabilityResponse = {
  __typename?: 'BookingFlowCartGetProductAvailabilityResponse';
  offer?: Maybe<Array<Maybe<BookingFlowCartProductOfferData>>>;
};

export type BookingFlowCartProductOfferData = {
  __typename?: 'BookingFlowCartProductOfferData';
  available?: Maybe<Scalars['Int']['output']>;
  componentId?: Maybe<Scalars['String']['output']>;
  componentType?: Maybe<Scalars['String']['output']>;
  expire?: Maybe<Scalars['Float']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  subOffers?: Maybe<Array<Maybe<BookingFlowCartProductSubOfferData>>>;
  time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartProductSubOfferData = {
  __typename?: 'BookingFlowCartProductSubOfferData';
  additionalInfo?: Maybe<Scalars['JSON']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  subIdType?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartRemoveGiftCardRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  giftCard?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartRemoveItemRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartSpaCartCustomerModel = {
  __typename?: 'BookingFlowCartSpaCartCustomerModel';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartSpaCartDataModel = {
  __typename?: 'BookingFlowCartSpaCartDataModel';
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<BookingFlowCartSpaCartCustomerModel>;
  discountedAmount?: Maybe<Scalars['Float']['output']>;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  expirationLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  giftCardPaymentAmount?: Maybe<Scalars['Float']['output']>;
  giftCards?: Maybe<Array<Maybe<BookingFlowCartSpaGiftCardModel>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<BookingFlowCartSpaCartItemDataModel>>>;
  membership?: Maybe<BookingFlowCartDtoMembershipInfo>;
  originalItems?: Maybe<Array<Maybe<BookingFlowCartSpaCartItemDataModel>>>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentRequired?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  validationIssues?: Maybe<Array<Maybe<BookingFlowCartDtoValidationIssue>>>;
};

export type BookingFlowCartSpaCartItemDataModel = {
  __typename?: 'BookingFlowCartSpaCartItemDataModel';
  discountedPrice?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fixedDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  linePrice?: Maybe<Scalars['Float']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reservationStatus?: Maybe<Scalars['String']['output']>;
  totalLinePrice?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartSpaGiftCardModel = {
  __typename?: 'BookingFlowCartSpaGiftCardModel';
  balance?: Maybe<Scalars['Float']['output']>;
  chargeAmount?: Maybe<Scalars['Float']['output']>;
  no?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowCartStoreCustomerModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  customer?: InputMaybe<BookingFlowCustomerModelInput>;
};

export type BookingFlowCartTransactionMcpModelInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  retrievalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartTransactionModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  mcp?: InputMaybe<BookingFlowCartTransactionMcpModelInput>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowCartUpdateItemRequestModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  hotelBookingRef?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingFlowConcactModelInput = {
  email: Scalars['NonEmptyString']['input'];
  firstName: Scalars['NonEmptyString']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['NonEmptyString']['input'];
  personalId: Scalars['NonEmptyString']['input'];
  phoneNumber: Scalars['NonEmptyString']['input'];
};

export type BookingFlowCustomerModelInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowFinalizeGiftCardModelInput = {
  giftCardNo?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowFindGiftCardRequestModelInput = {
  giftCardNo?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowGetProductAvailabilityRequestModelInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isDaily?: InputMaybe<Scalars['Boolean']['input']>;
  isMembership?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingFlowGiftCardOrderModel = {
  __typename?: 'BookingFlowGiftCardOrderModel';
  amount?: Maybe<Scalars['Int']['output']>;
  caseAmount?: Maybe<Scalars['Int']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  externalDocNo?: Maybe<Scalars['String']['output']>;
  giftCardName?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  recipientAddress2?: Maybe<Scalars['String']['output']>;
  recipientCountryCode?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientPhoneNumber?: Maybe<Scalars['String']['output']>;
  recipientPostCode?: Maybe<Scalars['String']['output']>;
  shippingAmount?: Maybe<Scalars['Int']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
};

export type BookingFlowGiftCardOrderModelInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  caseAmount?: InputMaybe<Scalars['Int']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  externalDocNo?: InputMaybe<Scalars['String']['input']>;
  giftCardName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  recipientAddress?: InputMaybe<Scalars['String']['input']>;
  recipientAddress2?: InputMaybe<Scalars['String']['input']>;
  recipientCountryCode?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  recipientPostCode?: InputMaybe<Scalars['String']['input']>;
  shippingAmount?: InputMaybe<Scalars['Int']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowGiftCardPaymentAuthorizationModelInput = {
  cres?: InputMaybe<Scalars['String']['input']>;
  giftCardNo: Scalars['NonEmptyString']['input'];
  pares?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowGiftCardTdsmCheckModelInput = {
  giftCardNo: Scalars['NonEmptyString']['input'];
};

export type BookingFlowMembershipLoginModelInput = {
  phoneNumber: Scalars['NonEmptyString']['input'];
};

export type BookingFlowMembershipLoginValidateSmsCodeModelInput = {
  phoneNumber: Scalars['NonEmptyString']['input'];
  smsCode: Scalars['NonEmptyString']['input'];
};

export type BookingFlowMembershipModelInput = {
  cardHolder: BookingFlowConcactModelInput;
  cardHolder2?: InputMaybe<BookingFlowConcactModelInput>;
  newsletter: Scalars['Boolean']['input'];
  payer: BookingFlowPayerModelInput;
  productId: Scalars['NonEmptyString']['input'];
};

export type BookingFlowMembershipPaymentAuthorizationModelInput = {
  cres?: InputMaybe<Scalars['String']['input']>;
  membershipRef: Scalars['NonEmptyString']['input'];
  pares?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowMembershipTdsmCheckModelInput = {
  membershipRef: Scalars['NonEmptyString']['input'];
};

export type BookingFlowOrderGiftCardModelInput = {
  giftCard?: InputMaybe<BookingFlowGiftCardOrderModelInput>;
  paymentInfo?: InputMaybe<BookingFlowPaymentInfoModelInput>;
};

export type BookingFlowOrderMembershipFinalizeTransactionModelInput = {
  membershipId?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowOrderMembershipModelInput = {
  membership: BookingFlowMembershipModelInput;
  paymentInfo: BookingFlowPaymentInfoModelInput;
};

export type BookingFlowOrderMembershipTransactionModelInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  membership?: InputMaybe<BookingFlowMembershipModelInput>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowPayerModelInput = {
  email: Scalars['NonEmptyString']['input'];
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  phoneNumber: Scalars['NonEmptyString']['input'];
};

export type BookingFlowPaymentAuthorizationModelInput = {
  bookingId: Scalars['NonEmptyString']['input'];
  cres?: InputMaybe<Scalars['String']['input']>;
  pares?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowPaymentInfoModelInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cvc?: InputMaybe<Scalars['String']['input']>;
  expireMonth?: InputMaybe<Scalars['String']['input']>;
  expireYear?: InputMaybe<Scalars['String']['input']>;
  paymentSessionData?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  tdsmNotificationUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BookingFlowRequestMembershipCardSmsCodeModelInput = {
  membershipType: Scalars['NonEmptyString']['input'];
  phoneNumber: Scalars['NonEmptyString']['input'];
};

export type BookingFlowSetRecommendedTransferLocationsModelInput = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type BookingFlowStartPaymentModelInput = {
  businessProcess?: InputMaybe<BlLsRetailODataPlanetEnumsTransactionBusinessProcess>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentInfo: BookingFlowPaymentInfoModelInput;
};

export type BookingFlowTdsmCheckModelInput = {
  bookingId: Scalars['NonEmptyString']['input'];
};

export type BookingFlowValidateMembershipCardModelInput = {
  membershipType: Scalars['NonEmptyString']['input'];
  phoneNumber: Scalars['NonEmptyString']['input'];
  smsCode: Scalars['NonEmptyString']['input'];
};

export type BookingFlowValidateMembershipEmailModelInput = {
  email: Scalars['NonEmptyString']['input'];
  productId: Scalars['NonEmptyString']['input'];
};

export type BookingFlowValidateMembershipPhoneNumberModelInput = {
  phoneNumber: Scalars['NonEmptyString']['input'];
  productId: Scalars['NonEmptyString']['input'];
};

export type BookingGiftCardResponseModel = {
  __typename?: 'BookingGiftCardResponseModel';
  chargeAmount?: Maybe<Scalars['Int']['output']>;
  giftCardName?: Maybe<Scalars['String']['output']>;
  giftCardNo?: Maybe<Scalars['String']['output']>;
  remainingAmount?: Maybe<Scalars['Int']['output']>;
};

export type BookingItemResponseModel = {
  __typename?: 'BookingItemResponseModel';
  created?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  itemPrice?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  noOfPersons?: Maybe<Scalars['Int']['output']>;
  productDiscount?: Maybe<Scalars['Int']['output']>;
  productDiscountedPrice?: Maybe<Scalars['Int']['output']>;
  productPrice?: Maybe<Scalars['Int']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reservationDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BookingItemState>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export enum BookingItemState {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  NoAvailability = 'NO_AVAILABILITY',
  Pending = 'PENDING',
  PendingRemoval = 'PENDING_REMOVAL',
  Removed = 'REMOVED',
  Reserved = 'RESERVED',
  WaitingOnApproval = 'WAITING_ON_APPROVAL'
}

export type BookingItemStateLinkRequestModelInput = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tempId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingItemStateUpdateRequestModelInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  changeType?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  groupNo?: InputMaybe<Scalars['String']['input']>;
  lineNo?: InputMaybe<Scalars['Int']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
  noOfPersons?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reservationDate?: InputMaybe<Scalars['DateTime']['input']>;
  reservationTime?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  systemCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  systemId?: InputMaybe<Scalars['UUID']['input']>;
  systemModifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unitPrice?: InputMaybe<Scalars['Int']['input']>;
  upgradeStatus?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BookingMutation = {
  __typename?: 'BookingMutation';
  deleteBokunApiBooking?: Maybe<Scalars['JSON']['output']>;
  deleteBokunApiBookingTransport?: Maybe<Scalars['JSON']['output']>;
  deleteMybookingActivityCancelByLineNo?: Maybe<MyBookingCancelActivityLineResponse>;
  deleteMybookingHotelActivityCancelByBookingRefByLineNo?: Maybe<MyBookingCancelActivityLineResponse>;
  deleteMybookingHotelActivityCancelByLineNo?: Maybe<MyBookingCancelActivityLineResponse>;
  deleteMybookingHotelExtraByBookingRefByLineNo?: Maybe<MyBookingUpdateHotelRoomResponseModel>;
  deleteMybookingHotelExtraByLineNo?: Maybe<MyBookingUpdateHotelRoomResponseModel>;
  /** Removes the specified channel configuration from the product catalog using the channel name provided in the route. */
  deleteProductcatalogconfigChannelsByChannelName?: Maybe<Scalars['Void']['output']>;
  /** Removes the specified product type from the product catalog using the provided product type name. */
  deleteProductcatalogconfigProductTypesByProductTypeName?: Maybe<Scalars['Void']['output']>;
  /** Removes the specified product from the product catalog using the provided product ID. */
  deleteProductcatalogconfigProductsById?: Maybe<Scalars['Void']['output']>;
  /** Removes the specified system configuration from the product catalog using the system name provided in the route. */
  deleteProductcatalogconfigSystemsBySystemName?: Maybe<Scalars['Void']['output']>;
  postBokunApiBooking?: Maybe<Scalars['JSON']['output']>;
  postBokunApiBookingConfirm?: Maybe<Scalars['JSON']['output']>;
  postBokunApiBookingTransportBack?: Maybe<Scalars['JSON']['output']>;
  postBokunApiBookingTransportForth?: Maybe<Scalars['JSON']['output']>;
  /** Order new unissued gift card. */
  postBookingflowServerGiftcardCreate?: Maybe<GiftCardCreateGiftCardResponse>;
  /** Finalize an unissued gift card. */
  postBookingflowServerGiftcardFinalize?: Maybe<GiftCardFinalizeGiftCardResponse>;
  /** Find gift card. */
  postBookingflowServerGiftcardFind?: Maybe<GiftCardGetGiftCardResponse>;
  /** Order new gift card. */
  postBookingflowServerGiftcardOrder?: Maybe<GiftCardOrderGiftCardResponse>;
  /** Additional operation for the 3D Secure processing: TDSM Check. */
  postBookingflowServerGiftcardTdsmCheck?: Maybe<GiftCardGiftCardTdsmCheckResponse>;
  /** Validate ACS Authorization result and finalize the gift card order. */
  postBookingflowServerGiftcardValidatePayment?: Maybe<GiftCardValidateGiftCardPaymentResponse>;
  /** Request Membership Login by phone number (2 factor validation). */
  postBookingflowServerMembershipLogin?: Maybe<Scalars['JSON']['output']>;
  /** Validate Membership Login by SMS Code and retrieve membership details. */
  postBookingflowServerMembershipLoginValidate?: Maybe<MembershipValidateMembershipSmsCodeResponse>;
  /** Order new membership and initiate payment process. */
  postBookingflowServerMembershipOrder?: Maybe<MembershipOrderMembershipResponse>;
  /** Request Membership Card SMS Code for validation. */
  postBookingflowServerMembershipRequestSms?: Maybe<Scalars['JSON']['output']>;
  /** Additional operation for the 3D Secure processing: TDSM Check. */
  postBookingflowServerMembershipTdsmCheck?: Maybe<MembershipMembershipTdsmCheckResponse>;
  /** Validate Membership Email address. */
  postBookingflowServerMembershipValidateEmail?: Maybe<MembershipValidateMembershipEmailResponse>;
  /** Validate ACS Authorization result and finalize the membership order. */
  postBookingflowServerMembershipValidatePayment?: Maybe<MembershipValidateMembershipPaymentResponse>;
  /** Validate Membership Phone Number. */
  postBookingflowServerMembershipValidatePhoneNumber?: Maybe<MembershipValidateMembershipPhoneNumberResponse>;
  /** Validate Membership Card by SMS Code. */
  postBookingflowServerMembershipValidateSms?: Maybe<MembershipValidateMembershipSmsCodeResponse>;
  /** Additional operation for the 3D Secure processing: TDSM Check. */
  postBookingflowServerTdsmCheck?: Maybe<Scalars['JSON']['output']>;
  /** Validate ACS Authorization result and finalize the confirmation. */
  postBookingflowServerValidatePayment?: Maybe<BookingValidatePaymentResponse>;
  /** Add an item to the cart. */
  postCartActivityAdd?: Maybe<ActivityCartActivityCartDataModel>;
  /** Add a gift card to the cart. Multiple can be added. */
  postCartActivityAddGiftCard?: Maybe<ActivityCartActivityCartDataModel>;
  /** Add a membership token to the cart. The membership token is gained by calling membership/login and membership/login-validate calls. */
  postCartActivityAddMembershipToken?: Maybe<ActivityCartActivityCartDataModel>;
  /** Add a promotional code to the cart. */
  postCartActivityAddPromoCode?: Maybe<ActivityCartActivityCartDataModel>;
  /** Checkout and finalize the payment process. */
  postCartActivityCheckout?: Maybe<ActivityCartActivityCartCheckoutResponse>;
  /** Store customer information in cart. */
  postCartActivityCustomer?: Maybe<ActivityCartActivityCartStoreCustomerResponse>;
  /** Create a new cart. */
  postCartActivityNew?: Maybe<ActivityCartActivityCartDataModel>;
  /** Remove an item from the cart. */
  postCartActivityRemove?: Maybe<ActivityCartActivityCartDataModel>;
  /** Remove a gift card from the cart. */
  postCartActivityRemoveGiftCard?: Maybe<ActivityCartActivityCartDataModel>;
  /** Remove the membership token from the cart. */
  postCartActivityRemoveMembershipTokenById?: Maybe<ActivityCartActivityCartDataModel>;
  /** Clear the cart by removing all items */
  postCartActivityResetByCartId?: Maybe<ActivityCartActivityCartDataModel>;
  /** Initiate the payment process */
  postCartActivityTransaction?: Maybe<ActivityCartActivityCartTransactionResponse>;
  /** Add an item to the cart. */
  postCartDayspaAdd?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Add a gift card to the cart. Multiple can be added. */
  postCartDayspaAddGiftCard?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Add a membership token to the cart. The membership token is gained by calling membership/login and membership/login-validate calls. */
  postCartDayspaAddMembershipToken?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Add a promotional code to the cart. */
  postCartDayspaAddPromoCode?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Checkout and finalize the payment process. */
  postCartDayspaCheckout?: Maybe<BookingFlowCartBookingFlowCartCheckoutResponse>;
  /** Store customer information in cart. */
  postCartDayspaCustomer?: Maybe<BookingFlowCartBookingFlowCartStoreCustomerResponse>;
  /** Create a new cart. */
  postCartDayspaNew?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Remove an item from the cart. */
  postCartDayspaRemove?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Remove a gift card from the cart. */
  postCartDayspaRemoveGiftCard?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Remove the membership token from the cart. */
  postCartDayspaRemoveMembershipTokenById?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Clear the cart by removing all items */
  postCartDayspaResetByCartId?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Initiate the payment process */
  postCartDayspaTransaction?: Maybe<BookingFlowCartBookingFlowCartTransactionResponse>;
  /** Set recommended transport pickup/dropoff locations. */
  postCartDayspaTransferUpdateRecommendedLocations?: Maybe<ProductCatalogSetRecommendedTransportLocationsResponse>;
  /** Add an item to the cart. */
  postCartHotelAdd?: Maybe<HotelCartDtoHotelCartData>;
  /** Checkout and initiate the payment process. */
  postCartHotelCheckout?: Maybe<HotelCartHotelCartCheckoutResponse>;
  /** Store Customer details. */
  postCartHotelCustomer?: Maybe<HotelCartHotelCartStoreCustomerResponse>;
  /** Create a new cart. */
  postCartHotelNew?: Maybe<HotelCartDtoHotelCartData>;
  /** Get products availability for a specific time period. The function result is an offer, what should be referenced when the product with availability added to the cart. */
  postCartHotelProductAvailability?: Maybe<BookingFlowCartGetProductAvailabilityResponse>;
  /** Remove an item from the cart. */
  postCartHotelRemove?: Maybe<HotelCartDtoHotelCartData>;
  /** Clear the cart by removing all items */
  postCartHotelResetByCartId?: Maybe<HotelCartDtoHotelCartData>;
  /** Get room availability for a specific time period. The offers are summarized (by prize and availability). */
  postCartHotelRoomAvailabilitySummary?: Maybe<HotelCartHotelAvailabilityResponse>;
  /** Initiate the payment process */
  postCartHotelTransaction?: Maybe<HotelCartHotelCartTransactionResponse>;
  /** Update an item in the cart. */
  postCartHotelUpdate?: Maybe<HotelCartDtoHotelCartData>;
  postConfigComfortRatio?: Maybe<ConfigComfortRatioResponse>;
  postConfigGetActiveRefundPolicy?: Maybe<DataGetAllActiveRefundPoliciesReponse>;
  postConfigStaffTickets?: Maybe<StaffTicketsStaffTicketSetupModel>;
  postConfigStormPolicies?: Maybe<Scalars['JSON']['output']>;
  postConfigStormPoliciesAgent?: Maybe<Scalars['JSON']['output']>;
  postFastcheckinFastCheckin?: Maybe<Scalars['JSON']['output']>;
  /** Updates the Guest Information and pre-checkin. */
  postHotelbookingflowServerGuestRegistrationFinalizeByReservationNo?: Maybe<HotelReservationGuestRegistrationContractFinalizeGuestRegistrationResponse>;
  /** Creates a GuestRegistration Contract. */
  postHotelbookingflowServerGuestRegistrationInitiateByReservationNo?: Maybe<HotelReservationGuestRegistrationContractFinalizeGuestRegistrationResponse>;
  /** Attach a PDF to a hotel Reservation. */
  postHotelbookingflowServerReservationAttachment?: Maybe<HotelReservationCreateHotelReservationAttachmentResponse>;
  postHotelpaymentHotelsCollectRecordLines?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentHotelsTasks?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentHotelsTasksCharge?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentHotelsTasksClose?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentHotelsTasksGroupcharge?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentHotelsTasksOpen?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentHotelsTasksTotal?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentMultitokenCharge?: Maybe<Scalars['JSON']['output']>;
  postHotelpaymentMultitokenValidate?: Maybe<Scalars['JSON']['output']>;
  /** Request Membership Login by phone number (2 factor validation). */
  postMembershipLogin?: Maybe<Scalars['JSON']['output']>;
  /** Validate Membership Login by SMS Code and retrieve membership details. */
  postMembershipLoginValidate?: Maybe<MembershipValidateMembershipSmsCodeResponse>;
  /** Order new membership and initiate payment process. */
  postMembershipOrder?: Maybe<MembershipOrderMembershipResponse>;
  /** Request Membership Card SMS Code for validation. */
  postMembershipRequestSms?: Maybe<Scalars['JSON']['output']>;
  /** Additional operation for the 3D Secure processing: TDSM Check. */
  postMembershipTdsmCheck?: Maybe<MembershipMembershipTdsmCheckResponse>;
  postMembershipTransactionFinalize?: Maybe<MembershipMembershipFinalizePaymentResponse>;
  postMembershipTransactionInit?: Maybe<MembershipMembershipInitTransactionResponse>;
  /** Validate Membership Email address. */
  postMembershipValidateEmail?: Maybe<MembershipValidateMembershipEmailResponse>;
  /** Validate ACS Authorization result and finalize the membership order. */
  postMembershipValidatePayment?: Maybe<MembershipValidateMembershipPaymentResponse>;
  /** Validate Membership Phone Number. */
  postMembershipValidatePhoneNumber?: Maybe<MembershipValidateMembershipPhoneNumberResponse>;
  /** Validate Membership Card by SMS Code. */
  postMembershipValidateSms?: Maybe<MembershipValidateMembershipSmsCodeResponse>;
  postMybookingActivityAdd?: Maybe<MyBookingAddActivityLineResponse>;
  postMybookingActivityUpdate?: Maybe<MyBookingUpdateActivityLineResponse>;
  postMybookingActivityUpgrade?: Maybe<MyBookingUpgradeActivityLineResponse>;
  postMybookingAvailableRefund?: Maybe<DataGetAvailableRefundResponse>;
  postMybookingAvailableRefundInfo?: Maybe<DataGetAvailableRefundInfoResponse>;
  postMybookingBustransfer?: Maybe<MyBookingAddBusTransferResponse>;
  postMybookingCancelBooking?: Maybe<BookingCancelBookingResponse>;
  postMybookingChangeDateTime?: Maybe<Scalars['JSON']['output']>;
  postMybookingChangePassword?: Maybe<MyBookingChangePasswordResponse>;
  postMybookingCreateUser?: Maybe<MyBookingCreateOrUpdateUserResponse>;
  postMybookingDownloadDblTicketArrival?: Maybe<Scalars['File']['output']>;
  postMybookingDownloadDblTicketDeparture?: Maybe<Scalars['File']['output']>;
  postMybookingDownloadReceipt?: Maybe<Scalars['File']['output']>;
  postMybookingDownloadSpaVoucher?: Maybe<Scalars['File']['output']>;
  postMybookingGetAllBookings?: Maybe<MyBookingGetAllBookingsResponse>;
  postMybookingHotelActivities?: Maybe<MyBookingHotelAddActivitiesToHotelResponse>;
  postMybookingHotelActivityAdd?: Maybe<MyBookingAddActivityLineResponse>;
  postMybookingHotelActivityUpdate?: Maybe<MyBookingUpdateActivityLineResponse>;
  postMybookingHotelCancelBooking?: Maybe<BookingCancelBookingResponse>;
  postMybookingHotelComment?: Maybe<Scalars['JSON']['output']>;
  postMybookingHotelExtra?: Maybe<MyBookingUpdateHotelRoomResponseModel>;
  postMybookingHotelExtras?: Maybe<MyBookingHotelAddReservationExtrasToHotelResponse>;
  postMybookingHotelLogin?: Maybe<BlBookingApiSecurityModelsJwtTokenResult>;
  postMybookingHotelPaymentTokenFinalize?: Maybe<Scalars['Void']['output']>;
  postMybookingHotelPaymentTokenInitialize?: Maybe<MyBookingHotelInitializeHotelPaymentTokenResponse>;
  postMybookingItinerary?: Maybe<DataGetBookingItineraryItemsResponse>;
  postMybookingLogin?: Maybe<BlBookingApiSecurityModelsJwtTokenResult>;
  postMybookingLoginV2?: Maybe<BlBookingApiSecurityModelsJwtTokenResult>;
  postMybookingLoginWithPassword?: Maybe<BlBookingApiSecurityModelsJwtTokenResult>;
  postMybookingPasssource?: Maybe<MyBookingPassSourceResponseModel>;
  postMybookingPreferences?: Maybe<BlcpAddPreferencesResponse>;
  postMybookingReceipt?: Maybe<DataGetBookingReceiptItemsResponse>;
  postMybookingRefreshToken?: Maybe<BlBookingApiSecurityModelsJwtTokenResult>;
  postMybookingResetPassword?: Maybe<MyBookingResetPasswordResponse>;
  postMybookingRetailAdd?: Maybe<MyBookingAddRetailItemResponse>;
  postMybookingSendPasswordResetEmail?: Maybe<MyBookingSendPasswordResetEmailResponse>;
  postMybookingTransactionCancel?: Maybe<MyBookingCancelMyBookingPaymentResponse>;
  postMybookingTransactionFinalize?: Maybe<MyBookingMyBookingFinalizePaymentResponse>;
  postMybookingTransactionInit?: Maybe<MyBookingMyBookingInitTransactionResponse>;
  postMybookingUpdateUser?: Maybe<MyBookingCreateOrUpdateUserResponse>;
  /** Refund booking payment and create subsequent deposit */
  postPaymentBookingRefund?: Maybe<PostApiV1PaymentBookingRefundResponse>;
  /** Merchant initiated payment that charges a token for the given amount */
  postPaymentChargeToken?: Maybe<PostApiV1PaymentChargeTokenResponse>;
  /** Initiate a payment process. */
  postPaymentStart?: Maybe<Scalars['JSON']['output']>;
  /** Additional operation for the 3D Secure processing: TDSM Check. */
  postPaymentTdsmCheck?: Maybe<Scalars['JSON']['output']>;
  /** Create transaction for specific token and or amount */
  postPaymentTransaction?: Maybe<PostApiV1PaymentTransactionResponse>;
  /** Authorize a pre-authenticated transaction or Secure Fields transaction */
  postPaymentTransactionAuthorizeAuthenticated?: Maybe<PostApiV1PaymentTransactionAuthorizeAuthenticatedResponse>;
  /** Cancel payment that has not been settled */
  postPaymentTransactionCancel?: Maybe<PostApiV1PaymentTransactionCancelResponse>;
  postPaymentTransactionHook?: Maybe<MicrosoftAspNetCoreMvcProblemDetails>;
  /** Refund payment */
  postPaymentTransactionRefund?: Maybe<PostApiV1PaymentTransactionRefundResponse>;
  /** Create transaction for specific amount to be used with secure fields */
  postPaymentTransactionSecureField?: Maybe<PostApiV1PaymentTransactionSecureFieldResponse>;
  /** Settle payment */
  postPaymentTransactionSettle?: Maybe<PostApiV1PaymentTransactionSettleResponse>;
  /** Validate ACS Authorization result and finalize the confirmation. */
  postPaymentValidate?: Maybe<PostApiV1PaymentValidateResponse>;
  /** Adds a new channel to the product catalog configuration. Requires a valid channel configuration object in the request body. */
  postProductcatalogconfigChannels?: Maybe<Scalars['JSON']['output']>;
  /** Adds one or more products to the specified channel configuration using the channel name provided in the route. */
  postProductcatalogconfigChannelsByChannelNameProducts?: Maybe<Scalars['JSON']['output']>;
  /** Adds a new product type to the product catalog using the details provided in the request body. */
  postProductcatalogconfigProductTypes?: Maybe<Scalars['JSON']['output']>;
  /** Adds a new system entry to the product catalog configuration. Requires a valid system configuration object in the request body. */
  postProductcatalogconfigSystems?: Maybe<Scalars['JSON']['output']>;
  /** Adds new products to the specified system within the product catalog configuration. Requires the system name in the route and the products details in the request body. */
  postProductcatalogconfigSystemsBySystemNameProducts?: Maybe<Scalars['JSON']['output']>;
  putBokunApiBooking?: Maybe<Scalars['JSON']['output']>;
  putMybookingBustransferUpdate?: Maybe<MyBookingUpdateBusTransferResponse>;
  putMybookingHotelRoom?: Maybe<MyBookingUpdateHotelRoomResponseModel>;
  /** Updates the configuration of the specified channel in the product catalog. Requires the channel name in the route and the updated configuration in the request body. */
  putProductcatalogconfigChannelsByChannelName?: Maybe<Scalars['JSON']['output']>;
  /** Updates the details of an existing product type in the product catalog using the specified product type name with the provided data. */
  putProductcatalogconfigProductTypesByProductTypeName?: Maybe<Scalars['JSON']['output']>;
  /** Updates the details of an existing product in the product catalog using the specified product ID. */
  putProductcatalogconfigProductsById?: Maybe<Scalars['JSON']['output']>;
  /** Updates the configuration of the specified system in the product catalog. Requires the system name in the route and the updated configuration in the request body. */
  putProductcatalogconfigSystemsBySystemName?: Maybe<Scalars['JSON']['output']>;
};


export type BookingMutationDeleteBokunApiBookingArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunCancelBookingModelInput>;
};


export type BookingMutationDeleteBokunApiBookingTransportArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunRemoveTransportRouteModelInput>;
};


export type BookingMutationDeleteMybookingActivityCancelByLineNoArgs = {
  lineNo: Scalars['String']['input'];
};


export type BookingMutationDeleteMybookingHotelActivityCancelByBookingRefByLineNoArgs = {
  bookingRef: Scalars['String']['input'];
  lineNo: Scalars['String']['input'];
};


export type BookingMutationDeleteMybookingHotelActivityCancelByLineNoArgs = {
  lineNo: Scalars['String']['input'];
};


export type BookingMutationDeleteMybookingHotelExtraByBookingRefByLineNoArgs = {
  bookingRef: Scalars['String']['input'];
  lineNo: Scalars['Int']['input'];
};


export type BookingMutationDeleteMybookingHotelExtraByLineNoArgs = {
  lineNo: Scalars['Int']['input'];
};


export type BookingMutationDeleteProductcatalogconfigChannelsByChannelNameArgs = {
  channelName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
};


export type BookingMutationDeleteProductcatalogconfigProductTypesByProductTypeNameArgs = {
  configKey: Scalars['String']['input'];
  productTypeName: Scalars['String']['input'];
};


export type BookingMutationDeleteProductcatalogconfigProductsByIdArgs = {
  configKey: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type BookingMutationDeleteProductcatalogconfigSystemsBySystemNameArgs = {
  configKey: Scalars['String']['input'];
  systemName: Scalars['String']['input'];
};


export type BookingMutationPostBokunApiBookingArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunCreateBookingModelInput>;
};


export type BookingMutationPostBokunApiBookingConfirmArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunConfirmBookingModelInput>;
};


export type BookingMutationPostBokunApiBookingTransportBackArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunAddTransportBackRouteModelInput>;
};


export type BookingMutationPostBokunApiBookingTransportForthArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunAddTransportForthRouteModelInput>;
};


export type BookingMutationPostBookingflowServerGiftcardCreateArgs = {
  input?: InputMaybe<BookingFlowGiftCardOrderModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerGiftcardFinalizeArgs = {
  input?: InputMaybe<BookingFlowFinalizeGiftCardModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerGiftcardFindArgs = {
  input?: InputMaybe<BookingFlowFindGiftCardRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerGiftcardOrderArgs = {
  input?: InputMaybe<BookingFlowOrderGiftCardModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerGiftcardTdsmCheckArgs = {
  input?: InputMaybe<BookingFlowGiftCardTdsmCheckModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerGiftcardValidatePaymentArgs = {
  input?: InputMaybe<BookingFlowGiftCardPaymentAuthorizationModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipLoginArgs = {
  input?: InputMaybe<BookingFlowMembershipLoginModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipLoginValidateArgs = {
  input?: InputMaybe<BookingFlowMembershipLoginValidateSmsCodeModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipOrderArgs = {
  input?: InputMaybe<BookingFlowOrderMembershipModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipRequestSmsArgs = {
  input?: InputMaybe<BookingFlowRequestMembershipCardSmsCodeModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipTdsmCheckArgs = {
  input?: InputMaybe<BookingFlowMembershipTdsmCheckModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipValidateEmailArgs = {
  input?: InputMaybe<BookingFlowValidateMembershipEmailModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipValidatePaymentArgs = {
  input?: InputMaybe<BookingFlowMembershipPaymentAuthorizationModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipValidatePhoneNumberArgs = {
  input?: InputMaybe<BookingFlowValidateMembershipPhoneNumberModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerMembershipValidateSmsArgs = {
  input?: InputMaybe<BookingFlowValidateMembershipCardModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerTdsmCheckArgs = {
  input?: InputMaybe<BookingFlowTdsmCheckModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostBookingflowServerValidatePaymentArgs = {
  input?: InputMaybe<BookingFlowPaymentAuthorizationModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityAddArgs = {
  input?: InputMaybe<BookingFlowCartAddItemRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityAddGiftCardArgs = {
  input?: InputMaybe<BookingFlowCartAddGiftCardRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityAddMembershipTokenArgs = {
  input?: InputMaybe<BookingFlowCartAddMembershipTokenRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityAddPromoCodeArgs = {
  input?: InputMaybe<BookingFlowCartAddPromoCodeRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityCheckoutArgs = {
  input?: InputMaybe<BookingFlowCartConfirmModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityCustomerArgs = {
  input?: InputMaybe<BookingFlowCartStoreCustomerModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityNewArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityRemoveArgs = {
  input?: InputMaybe<BookingFlowCartRemoveItemRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityRemoveGiftCardArgs = {
  input?: InputMaybe<BookingFlowCartRemoveGiftCardRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityRemoveMembershipTokenByIdArgs = {
  id: Scalars['UUID']['input'];
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityResetByCartIdArgs = {
  cartId: Scalars['UUID']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartActivityTransactionArgs = {
  input?: InputMaybe<BookingFlowCartTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaAddArgs = {
  input?: InputMaybe<BookingFlowCartAddItemRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaAddGiftCardArgs = {
  input?: InputMaybe<BookingFlowCartAddGiftCardRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaAddMembershipTokenArgs = {
  input?: InputMaybe<BookingFlowCartAddMembershipTokenRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaAddPromoCodeArgs = {
  input?: InputMaybe<BookingFlowCartAddPromoCodeRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaCheckoutArgs = {
  input?: InputMaybe<BookingFlowCartConfirmModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaCustomerArgs = {
  input?: InputMaybe<BookingFlowCartStoreCustomerModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaNewArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaRemoveArgs = {
  input?: InputMaybe<BookingFlowCartRemoveItemRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaRemoveGiftCardArgs = {
  input?: InputMaybe<BookingFlowCartRemoveGiftCardRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaRemoveMembershipTokenByIdArgs = {
  id: Scalars['UUID']['input'];
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaResetByCartIdArgs = {
  cartId: Scalars['UUID']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaTransactionArgs = {
  input?: InputMaybe<BookingFlowCartTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartDayspaTransferUpdateRecommendedLocationsArgs = {
  input?: InputMaybe<BookingFlowSetRecommendedTransferLocationsModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelAddArgs = {
  input?: InputMaybe<BookingFlowCartAddItemRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelCheckoutArgs = {
  input?: InputMaybe<HotelCartConfirmCartModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelCustomerArgs = {
  input?: InputMaybe<HotelCartStoreCustomerCartModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelNewArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelProductAvailabilityArgs = {
  input?: InputMaybe<BookingFlowGetProductAvailabilityRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelRemoveArgs = {
  input?: InputMaybe<BookingFlowCartRemoveItemRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelResetByCartIdArgs = {
  cartId: Scalars['UUID']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelRoomAvailabilitySummaryArgs = {
  input?: InputMaybe<HotelCartRoomAvailabilityWithSummarizedOffersModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelTransactionArgs = {
  input?: InputMaybe<BookingFlowCartTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostCartHotelUpdateArgs = {
  input?: InputMaybe<BookingFlowCartUpdateItemRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostConfigComfortRatioArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ConfigSetComfortRatioRequestInput>;
};


export type BookingMutationPostConfigGetActiveRefundPolicyArgs = {
  configKey: Scalars['String']['input'];
};


export type BookingMutationPostConfigStaffTicketsArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<BlInternalApiFunctionsConfigurationSetStaffTicketConfigRequestInput>;
};


export type BookingMutationPostConfigStormPoliciesArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<PolicyConfigStormModelInput>;
};


export type BookingMutationPostConfigStormPoliciesAgentArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<PolicyConfigStormModelInput>;
};


export type BookingMutationPostFastcheckinFastCheckinArgs = {
  input?: InputMaybe<BcSetFastCheckinRequestInput>;
};


export type BookingMutationPostHotelbookingflowServerGuestRegistrationFinalizeByReservationNoArgs = {
  input?: InputMaybe<HotelReservationGuestRegistrationContractFinalizeGuestRegistrationRequestInput>;
  reservationNo: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelbookingflowServerGuestRegistrationInitiateByReservationNoArgs = {
  input?: InputMaybe<HotelReservationGuestRegistrationContractSetGuestRegistrationContractRequestInput>;
  reservationNo: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelbookingflowServerReservationAttachmentArgs = {
  input?: InputMaybe<HotelReservationCreateHotelReservationAttachmentRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsCollectRecordLinesArgs = {
  input?: InputMaybe<HotelPaymentCollectHotelBookingTaskLinesRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsTasksArgs = {
  input?: InputMaybe<HotelPaymentListHotelBookingTasksRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsTasksChargeArgs = {
  input?: InputMaybe<HotelPaymentChargeForHotelTaskRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsTasksCloseArgs = {
  input?: InputMaybe<HotelPaymentCloseHotelPaymentTaskRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsTasksGroupchargeArgs = {
  input?: InputMaybe<HotelPaymentChargeForGroupHotelTaskRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsTasksOpenArgs = {
  input?: InputMaybe<HotelPaymentOpenHotelPaymentTaskRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentHotelsTasksTotalArgs = {
  input?: InputMaybe<HotelPaymentHotelTaskDtoInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentMultitokenChargeArgs = {
  input?: InputMaybe<HotelPaymentChargePaymentTokenRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostHotelpaymentMultitokenValidateArgs = {
  input?: InputMaybe<HotelPaymentGetPaymentTokenRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipLoginArgs = {
  input?: InputMaybe<BookingFlowMembershipLoginModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipLoginValidateArgs = {
  input?: InputMaybe<BookingFlowMembershipLoginValidateSmsCodeModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipOrderArgs = {
  input?: InputMaybe<BookingFlowOrderMembershipModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipRequestSmsArgs = {
  input?: InputMaybe<BookingFlowRequestMembershipCardSmsCodeModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipTdsmCheckArgs = {
  input?: InputMaybe<BookingFlowMembershipTdsmCheckModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipTransactionFinalizeArgs = {
  input?: InputMaybe<BookingFlowOrderMembershipFinalizeTransactionModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipTransactionInitArgs = {
  input?: InputMaybe<BookingFlowOrderMembershipTransactionModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipValidateEmailArgs = {
  input?: InputMaybe<BookingFlowValidateMembershipEmailModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipValidatePaymentArgs = {
  input?: InputMaybe<BookingFlowMembershipPaymentAuthorizationModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipValidatePhoneNumberArgs = {
  input?: InputMaybe<BookingFlowValidateMembershipPhoneNumberModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMembershipValidateSmsArgs = {
  input?: InputMaybe<BookingFlowValidateMembershipCardModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingActivityAddArgs = {
  input?: InputMaybe<MyBookingAddActivityModelInput>;
};


export type BookingMutationPostMybookingActivityUpdateArgs = {
  input?: InputMaybe<MyBookingUpdateActivityModelInput>;
};


export type BookingMutationPostMybookingActivityUpgradeArgs = {
  input?: InputMaybe<MyBookingUpgradeActivityModelInput>;
};


export type BookingMutationPostMybookingAvailableRefundInfoArgs = {
  input?: InputMaybe<MyBookingAvailableRefundModelInput>;
};


export type BookingMutationPostMybookingBustransferArgs = {
  input?: InputMaybe<MyBookingMyBookingBusTransferModelInput>;
};


export type BookingMutationPostMybookingChangeDateTimeArgs = {
  input?: InputMaybe<MyBookingChangeDateTimeRequestDtoInput>;
};


export type BookingMutationPostMybookingChangePasswordArgs = {
  input?: InputMaybe<MyBookingChangePasswordRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingCreateUserArgs = {
  input?: InputMaybe<MyBookingCreateOrUpdateUserRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingGetAllBookingsArgs = {
  input?: InputMaybe<MyBookingGetAllBookingsRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingHotelActivitiesArgs = {
  input?: InputMaybe<Array<InputMaybe<MyBookingAddActivityModelInput>>>;
};


export type BookingMutationPostMybookingHotelActivityAddArgs = {
  input?: InputMaybe<MyBookingAddActivityModelInput>;
};


export type BookingMutationPostMybookingHotelActivityUpdateArgs = {
  input?: InputMaybe<MyBookingUpdateActivityModelInput>;
};


export type BookingMutationPostMybookingHotelCancelBookingArgs = {
  input?: InputMaybe<MyBookingCancelBookingModelInput>;
};


export type BookingMutationPostMybookingHotelCommentArgs = {
  input?: InputMaybe<MyBookingAddHotelCommentModelInput>;
};


export type BookingMutationPostMybookingHotelExtraArgs = {
  input?: InputMaybe<MyBookingHotelReservationExtraInput>;
};


export type BookingMutationPostMybookingHotelExtrasArgs = {
  input?: InputMaybe<Array<InputMaybe<MyBookingHotelReservationExtraInput>>>;
};


export type BookingMutationPostMybookingHotelLoginArgs = {
  input?: InputMaybe<BlBookingApiSecurityModelsMyBookingLoginInput>;
};


export type BookingMutationPostMybookingHotelPaymentTokenFinalizeArgs = {
  input?: InputMaybe<MyBookingUpdatePaymentTokenModelInput>;
};


export type BookingMutationPostMybookingHotelPaymentTokenInitializeArgs = {
  input?: InputMaybe<MyBookingHotelInitializeHotelPaymentTokenRequestInput>;
};


export type BookingMutationPostMybookingLoginArgs = {
  input?: InputMaybe<BlBookingApiSecurityModelsMyBookingLoginInput>;
};


export type BookingMutationPostMybookingLoginV2Args = {
  input?: InputMaybe<BlBookingApiSecurityModelsMyBookingLoginInput>;
};


export type BookingMutationPostMybookingLoginWithPasswordArgs = {
  input?: InputMaybe<MyBookingMyBookingLoginWithPasswordRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingPasssourceArgs = {
  input?: InputMaybe<MyBookingPassSourceRequestModelInput>;
};


export type BookingMutationPostMybookingPreferencesArgs = {
  input?: InputMaybe<BlcpAddPreferencesRequestInput>;
};


export type BookingMutationPostMybookingRefreshTokenArgs = {
  input?: InputMaybe<BlBookingApiSecurityModelsRefreshTokenDataInput>;
};


export type BookingMutationPostMybookingResetPasswordArgs = {
  input?: InputMaybe<MyBookingResetPasswordRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingRetailAddArgs = {
  input?: InputMaybe<MyBookingAddRetailItemModelInput>;
};


export type BookingMutationPostMybookingSendPasswordResetEmailArgs = {
  input?: InputMaybe<MyBookingSendPasswordResetEmailRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingTransactionCancelArgs = {
  input?: InputMaybe<MyBookingCancelTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingTransactionFinalizeArgs = {
  input?: InputMaybe<MyBookingFinalizeTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingTransactionInitArgs = {
  input?: InputMaybe<MyBookingMyBookingInitTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostMybookingUpdateUserArgs = {
  input?: InputMaybe<MyBookingCreateOrUpdateUserRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentBookingRefundArgs = {
  input?: InputMaybe<PaymentPlanetRefundBookingModelInput>;
  paymentKey: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentChargeTokenArgs = {
  input?: InputMaybe<PaymentPlanetInitializePaymentModelInput>;
  paymentKey: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentStartArgs = {
  input?: InputMaybe<BookingFlowStartPaymentModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTdsmCheckArgs = {
  input?: InputMaybe<PaymentPaymentTdsmRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTransactionArgs = {
  input?: InputMaybe<PaymentPlanetInitializePaymentModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTransactionAuthorizeAuthenticatedArgs = {
  input?: InputMaybe<PaymentPlanetAuthorizeAuthenticatedTransactionModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTransactionCancelArgs = {
  input?: InputMaybe<PaymentPlanetCancelPaymentModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTransactionRefundArgs = {
  input?: InputMaybe<PaymentPlanetRefundPaymentModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTransactionSecureFieldArgs = {
  input?: InputMaybe<PaymentPlanetInitializeSecureFieldsPaymentModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentTransactionSettleArgs = {
  input?: InputMaybe<PaymentPlanetUpdatePaymentModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostPaymentValidateArgs = {
  input?: InputMaybe<PaymentPaymentValidateRequestModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMutationPostProductcatalogconfigChannelsArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalChannelDataInput>;
};


export type BookingMutationPostProductcatalogconfigChannelsByChannelNameProductsArgs = {
  channelName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
  input?: InputMaybe<Array<InputMaybe<ProductCatalogLocalConfigDtoLocalProductDataInput>>>;
};


export type BookingMutationPostProductcatalogconfigProductTypesArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalProductTypeDataInput>;
};


export type BookingMutationPostProductcatalogconfigSystemsArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalSystemDataInput>;
};


export type BookingMutationPostProductcatalogconfigSystemsBySystemNameProductsArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<Array<InputMaybe<ProductCatalogLocalConfigDtoLocalProductDataInput>>>;
  systemName: Scalars['String']['input'];
};


export type BookingMutationPutBokunApiBookingArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunUpdateBookingModelInput>;
};


export type BookingMutationPutMybookingBustransferUpdateArgs = {
  input?: InputMaybe<MyBookingMyBookingBusTransferModelInput>;
};


export type BookingMutationPutMybookingHotelRoomArgs = {
  input?: InputMaybe<MyBookingMyBookingHotelRoomModelInput>;
};


export type BookingMutationPutProductcatalogconfigChannelsByChannelNameArgs = {
  channelName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalChannelDataInput>;
};


export type BookingMutationPutProductcatalogconfigProductTypesByProductTypeNameArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalProductTypeDataInput>;
  productTypeName: Scalars['String']['input'];
};


export type BookingMutationPutProductcatalogconfigProductsByIdArgs = {
  configKey: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalProductDataInput>;
};


export type BookingMutationPutProductcatalogconfigSystemsBySystemNameArgs = {
  configKey: Scalars['String']['input'];
  input?: InputMaybe<ProductCatalogLocalConfigDtoLocalSystemDataInput>;
  systemName: Scalars['String']['input'];
};

export type BookingQuery = {
  __typename?: 'BookingQuery';
  bokunApiActivities?: Maybe<Scalars['JSON']['output']>;
  bokunApiActivity?: Maybe<Scalars['JSON']['output']>;
  bokunApiAvailability?: Maybe<Scalars['JSON']['output']>;
  bokunApiBookingSession?: Maybe<Scalars['JSON']['output']>;
  /** List available error codes. */
  bookingflowServerErrors?: Maybe<Scalars['JSON']['output']>;
  /** Get Membership Products available. */
  bookingflowServerMembershipProducts?: Maybe<MembershipListMembershipProductsResponse>;
  /** Get available additional products for bookings. */
  bookingflowServerProducts?: Maybe<ProductCatalogGetProductsResponse>;
  /** Get an existing cart details. */
  cartActivityById?: Maybe<ActivityCartActivityCartDataModel>;
  /** Check status of cart checkout */
  cartActivityCheckByCartId?: Maybe<ActivityCartActivityCartPingCheckoutResponse>;
  /** Get available product types for cart operations. */
  cartActivityProductTypes?: Maybe<ProductCatalogGetProductTypesResponse>;
  /** Get available products for cart operations. */
  cartActivityProducts?: Maybe<ProductCatalogGetProductsResponse>;
  /** Get all transport pickup/dropoff locations */
  cartActivityTransferLocations?: Maybe<ProductCatalogGetTransportLocationsResponse>;
  /** Get an existing cart details. */
  cartDayspaById?: Maybe<BookingFlowCartSpaCartDataModel>;
  /** Check status of cart checkout */
  cartDayspaCheckByCartId?: Maybe<BookingFlowCartBookingFlowCartPingCheckoutResponse>;
  /** Get available product types for cart operations. */
  cartDayspaProductTypes?: Maybe<ProductCatalogGetProductTypesResponse>;
  /** Get available products for cart operations. */
  cartDayspaProducts?: Maybe<ProductCatalogGetProductsResponse>;
  /** Get all transport pickup/dropoff locations */
  cartDayspaTransferLocations?: Maybe<ProductCatalogGetTransportLocationsResponse>;
  /** Get a cart. */
  cartHotelById?: Maybe<HotelCartDtoHotelCartData>;
  /** Get available product types for cart operations. */
  cartHotelProductTypes?: Maybe<ProductCatalogGetProductTypesResponse>;
  /** Get available products for cart operations. */
  cartHotelProducts?: Maybe<ProductCatalogGetProductsResponse>;
  /** Returns a list of all rate codes */
  cartHotelRateCodes?: Maybe<HotelRateCodeGetRateCodeResponse>;
  /** Returns a list of all restrictions that apply to Rate Codes and Room Types */
  cartHotelRestrictions?: Maybe<HotelCartHotelRestrictionsResponse>;
  /** Returns a list of all restriction types */
  cartHotelRestrictionsTypes?: Maybe<HotelRestrictionRestrictionTypeResponse>;
  configComfortRatio?: Maybe<ConfigComfortRatioResponse>;
  configCurrentPoliciesInfo?: Maybe<Array<Maybe<DataGetCurrentPoliciesInfoResponse>>>;
  configCurrentPoliciesInfoAgent?: Maybe<Array<Maybe<DataGetCurrentPoliciesInfoResponse>>>;
  configStaffTickets?: Maybe<StaffTicketsStaffTicketSetupModel>;
  fastcheckinFastCheckinByBookingRef?: Maybe<Scalars['JSON']['output']>;
  /** Fetches the reservation using the supplied values. */
  hotelbookingflowServerGuestRegistrationByReservationNo?: Maybe<HotelReservationGuestRegistrationContractGetGuestRegistrationResponse>;
  hotelpaymentBookingsTasksStatuses?: Maybe<Scalars['JSON']['output']>;
  hotelpaymentHotelsCollectrecords?: Maybe<Scalars['JSON']['output']>;
  hotelpaymentHotelsTasksStatuses?: Maybe<Scalars['JSON']['output']>;
  /** Get Membership Products available. */
  membershipProducts?: Maybe<MembershipListMembershipProductsResponse>;
  mybookingActivities?: Maybe<MyBookingGetActivityLinesResponse>;
  mybookingActivityUpgrades?: Maybe<Array<Maybe<MyBookingActivityProductUpgradeModel>>>;
  mybookingAvailableRefundInfoByType?: Maybe<DataGetAvailableRefundInfoResponse>;
  mybookingBooking?: Maybe<MyBookingMyBookingInfoModel>;
  mybookingHotel?: Maybe<MyBookingHotelMyBookingHotelLoginResponse>;
  mybookingHotelActivityAvailableRefundInfo?: Maybe<MyBookingHotelActivityRefundInfoResponse>;
  mybookingHotelActivityChargeinfo?: Maybe<HotelReservationGetHotelChargeInfoResponse>;
  mybookingHotelExtraAvailableRefundInfo?: Maybe<MyBookingHotelExtraRefundInfoResponse>;
  mybookingHotelReceipt?: Maybe<DataGetHotelBookingReceiptItemsResponse>;
  mybookingPreferencesByBookingNumber?: Maybe<BlcpGetPreferencesResponse>;
  mybookingTransactions?: Maybe<MyBookingMyBookingGetTransactionsResponse>;
  /** Fetch card alias information */
  paymentAliasByAlias?: Maybe<ApiV1PaymentAliasByAliasResponse>;
  /** Get list of all supported currencies and their conversion rates without MCP surcharge */
  paymentCurrencyRates?: Maybe<ApiV1PaymentCurrencyRatesResponse>;
  /** Get list of all supported currencies and their conversion rates */
  paymentMulticurrencyRates?: Maybe<ApiV1PaymentMulticurrencyRatesResponse>;
  /** Fetch card alias from transaction id */
  paymentTransactionAliasByTransactionId?: Maybe<ApiV1PaymentTransactionAliasByTransactionIdResponse>;
  /** Create a link for customer to pay */
  paymentTransactionPaybylinkByRefnoByAmountByDuedate?: Maybe<ApiV1PaymentTransactionPaybylinkByRefnoByAmountByDuedateResponse>;
  /** Get payment status */
  paymentTransactionStatusBySearch?: Maybe<ApiV1PaymentTransactionStatusBySearchResponse>;
  /** Get products availability for a specific time period. The function result is an offer, what should be referenced when the product with availability added to the cart. */
  postCartActivityProductAvailability?: Maybe<ActivityCartGetProductAvailabilityResponse>;
  /** Get products availability for a specific time period. The function result is an offer, what should be referenced when the product with availability added to the cart. */
  postCartDayspaProductAvailability?: Maybe<BookingFlowCartGetProductAvailabilityResponse>;
  /** Get room availability for an extended specific time period. */
  postCartHotelRangeAvailability?: Maybe<HotelCartHotelAvailabilityRangeResponse>;
  /** Get disabled and checkoutonly slots of property for an extended specific time period. */
  postCartHotelRangeAvailabilityCalendar?: Maybe<HotelCartHotelUnavailabilityRangeResponse>;
  /** Get room availability for a specific time period. */
  postCartHotelRoomAvailability?: Maybe<HotelCartHotelAvailabilityResponse>;
  /** Returns a complete product catalog config (product types, systems, channels). */
  productcatalogconfig?: Maybe<ProductCatalogLocalConfigDtoLocalProductCatalogData>;
  /** Retrieves a list of channel configurations. If a channel name is specified as a query parameter, filters the results accordingly; otherwise, returns all channels. */
  productcatalogconfigChannels?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalChannelData>>>;
  /** Returns a list of all available product types in the product catalog. If a name is specified via query parameters, returns the corresponding product type. */
  productcatalogconfigProductTypes?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalProductTypeData>>>;
  /** Returns a list of products from the product catalog. If a product ID is specified via query parameters, returns the corresponding product. */
  productcatalogconfigProducts?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalProductData>>>;
  /** Retrieves a list of system configurations. If a name of system is specified as a query parameter, filters the results accordingly; otherwise, returns all systems. */
  productcatalogconfigSystems?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalSystemData>>>;
  skincareShopProductsById?: Maybe<Scalars['JSON']['output']>;
};


export type BookingQueryBokunApiActivitiesArgs = {
  apiKey: Scalars['String']['input'];
};


export type BookingQueryBokunApiActivityArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunGetActivityModelInput>;
};


export type BookingQueryBokunApiAvailabilityArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunGetAvailabilityModelInput>;
};


export type BookingQueryBokunApiBookingSessionArgs = {
  apiKey: Scalars['String']['input'];
  input?: InputMaybe<BokunGetBookingSessionModelInput>;
};


export type BookingQueryBookingflowServerMembershipProductsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryBookingflowServerProductsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartActivityByIdArgs = {
  id: Scalars['UUID']['input'];
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartActivityCheckByCartIdArgs = {
  cartId: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartActivityProductTypesArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartActivityProductsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartActivityTransferLocationsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartDayspaByIdArgs = {
  id: Scalars['UUID']['input'];
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartDayspaCheckByCartIdArgs = {
  cartId: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartDayspaProductTypesArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartDayspaProductsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartDayspaTransferLocationsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartHotelByIdArgs = {
  id: Scalars['UUID']['input'];
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartHotelProductTypesArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartHotelProductsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartHotelRateCodesArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartHotelRestrictionsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryCartHotelRestrictionsTypesArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryConfigComfortRatioArgs = {
  configKey: Scalars['String']['input'];
};


export type BookingQueryConfigCurrentPoliciesInfoArgs = {
  configKey: Scalars['String']['input'];
};


export type BookingQueryConfigCurrentPoliciesInfoAgentArgs = {
  configKey: Scalars['String']['input'];
};


export type BookingQueryConfigStaffTicketsArgs = {
  configKey: Scalars['String']['input'];
};


export type BookingQueryFastcheckinFastCheckinByBookingRefArgs = {
  bookingRef: Scalars['String']['input'];
};


export type BookingQueryHotelbookingflowServerGuestRegistrationByReservationNoArgs = {
  reservationNo: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryHotelpaymentBookingsTasksStatusesArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryHotelpaymentHotelsCollectrecordsArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryHotelpaymentHotelsTasksStatusesArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryMembershipProductsArgs = {
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryMybookingAvailableRefundInfoByTypeArgs = {
  type: Scalars['String']['input'];
};


export type BookingQueryMybookingPreferencesByBookingNumberArgs = {
  bookingNumber: Scalars['String']['input'];
};


export type BookingQueryMybookingTransactionsArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPaymentAliasByAliasArgs = {
  alias: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPaymentCurrencyRatesArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPaymentMulticurrencyRatesArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPaymentTransactionAliasByTransactionIdArgs = {
  transactionId: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPaymentTransactionPaybylinkByRefnoByAmountByDuedateArgs = {
  amount: Scalars['Float']['input'];
  duedate: Scalars['DateTime']['input'];
  refno: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPaymentTransactionStatusBySearchArgs = {
  search: Scalars['String']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPostCartActivityProductAvailabilityArgs = {
  input?: InputMaybe<BookingFlowGetProductAvailabilityRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPostCartDayspaProductAvailabilityArgs = {
  input?: InputMaybe<BookingFlowGetProductAvailabilityRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPostCartHotelRangeAvailabilityArgs = {
  input?: InputMaybe<HotelCartRoomAvailabilityRangeModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPostCartHotelRangeAvailabilityCalendarArgs = {
  input?: InputMaybe<HotelCartRoomUnavailabilityRangeModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryPostCartHotelRoomAvailabilityArgs = {
  input?: InputMaybe<HotelCartRoomAvailabilityModelInput>;
  xCorrelationId?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryProductcatalogconfigArgs = {
  configKey: Scalars['String']['input'];
};


export type BookingQueryProductcatalogconfigChannelsArgs = {
  configKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryProductcatalogconfigProductTypesArgs = {
  configKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQueryProductcatalogconfigProductsArgs = {
  configKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BookingQueryProductcatalogconfigSystemsArgs = {
  configKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type BookingQuerySkincareShopProductsByIdArgs = {
  id: Scalars['QueryInputApiV1SkincareShopProductsByIdId']['input'];
};

export type BookingResponseModel = {
  __typename?: 'BookingResponseModel';
  bookingItems?: Maybe<Array<Maybe<BookingItemResponseModel>>>;
  bookingRef?: Maybe<Scalars['String']['output']>;
  bookingType?: Maybe<BookingType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Total amount to be paid using GiftCards */
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  giftCards?: Maybe<Array<Maybe<BookingGiftCardResponseModel>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  paymentRequired?: Maybe<Scalars['Boolean']['output']>;
  paymentStatus?: Maybe<PaymentStateEnum>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BookingState>;
  toBePaid?: Maybe<Scalars['Float']['output']>;
  totalDiscountedPrice?: Maybe<Scalars['Float']['output']>;
  /** Total price of booking */
  totalPrice?: Maybe<Scalars['Float']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export enum BookingState {
  Cancelled = 'CANCELLED',
  Cancellednofee = 'CANCELLEDNOFEE',
  CheckoutInProgress = 'CHECKOUT_IN_PROGRESS',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Reserved = 'RESERVED'
}

export type BookingStateLinkRequestModelInput = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tempId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingStatePromoCodeItemRequestModelInput = {
  discount?: InputMaybe<Scalars['Int']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  tempId?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingStatePromoCodeRequestModelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<InputMaybe<BookingStatePromoCodeItemRequestModelInput>>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tempBookingRef?: InputMaybe<Scalars['String']['input']>;
};

export type BookingStateUpdateRequestModelInput = {
  changeType?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  internalStatus?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
  noOfPersons?: InputMaybe<Scalars['Int']['input']>;
  reservationType?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  systemCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  systemId?: InputMaybe<Scalars['UUID']['input']>;
  systemModifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum BookingType {
  Activity = 'ACTIVITY',
  Hotel = 'HOTEL'
}

export type BookingValidatePaymentResponse = {
  __typename?: 'BookingValidatePaymentResponse';
  bookingId?: Maybe<Scalars['String']['output']>;
};

export type BorgunPaymentModelMpiEnrollmentResponseAcsField = {
  __typename?: 'BorgunPaymentModelMpiEnrollmentResponseAcsField';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CheckoutBookingRequestModelInput = {
  groupBookingId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSingleBookingRequestModelInput = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigComfortRatioItem = {
  __typename?: 'ConfigComfortRatioItem';
  ratio?: Maybe<Scalars['Float']['output']>;
  slot?: Maybe<Scalars['DateTime']['output']>;
};

export type ConfigComfortRatioItemInput = {
  ratio?: InputMaybe<Scalars['Float']['input']>;
  slot?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigComfortRatioResponse = {
  __typename?: 'ConfigComfortRatioResponse';
  ratios?: Maybe<Array<Maybe<ConfigComfortRatioItem>>>;
};

export type ConfigSetComfortRatioRequestInput = {
  ratios?: InputMaybe<Array<InputMaybe<ConfigComfortRatioItemInput>>>;
};

export type CreateSingleBookingTransactionRequestModelInput = {
  bookingId?: InputMaybe<Scalars['UUID']['input']>;
  mcp?: InputMaybe<McpPaymentModelInput>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransactionRequestModelInput = {
  groupBookingId?: InputMaybe<Scalars['UUID']['input']>;
  mcp?: InputMaybe<McpPaymentModelInput>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransactionResponseModel = {
  __typename?: 'CreateTransactionResponseModel';
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type CreateTransactionSingleResponseModel = {
  __typename?: 'CreateTransactionSingleResponseModel';
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type CustomerResponseModel = {
  __typename?: 'CustomerResponseModel';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DataGetAllActiveRefundPoliciesReponse = {
  __typename?: 'DataGetAllActiveRefundPoliciesReponse';
  policyItems?: Maybe<Array<Maybe<BlBookingApiDataRefundPolicy>>>;
};

export type DataGetAvailableRefundInfoResponse = {
  __typename?: 'DataGetAvailableRefundInfoResponse';
  availableRefundPercentage?: Maybe<Scalars['Float']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  refundableAmount?: Maybe<Scalars['Float']['output']>;
  timeInHours?: Maybe<Scalars['Int']['output']>;
};

export type DataGetAvailableRefundResponse = {
  __typename?: 'DataGetAvailableRefundResponse';
  availableRefundPercentage?: Maybe<Scalars['Float']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type DataGetBookingItineraryItemsResponse = {
  __typename?: 'DataGetBookingItineraryItemsResponse';
  items?: Maybe<Array<Maybe<DataItineraryItem>>>;
};

export type DataGetBookingReceiptItemsResponse = {
  __typename?: 'DataGetBookingReceiptItemsResponse';
  deposit?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<Maybe<DataReceiptItem>>>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type DataGetCurrentPoliciesInfoResponse = {
  __typename?: 'DataGetCurrentPoliciesInfoResponse';
  currentPolicies?: Maybe<Array<Maybe<PolicyConfigCurrentPolicyInfo>>>;
  isStorm?: Maybe<Scalars['Boolean']['output']>;
};

export type DataGetHotelBookingReceiptItemsResponse = {
  __typename?: 'DataGetHotelBookingReceiptItemsResponse';
  items?: Maybe<Array<Maybe<DataHotelReceiptItem>>>;
};

export type DataHotelReceiptItem = {
  __typename?: 'DataHotelReceiptItem';
  activities?: Maybe<Array<Maybe<DataReceiptItem>>>;
  bookingRef?: Maybe<Scalars['String']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  extras?: Maybe<Array<Maybe<DataReceiptItem>>>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reservationLineNo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type DataItineraryItem = {
  __typename?: 'DataItineraryItem';
  time?: Maybe<Scalars['DateTime']['output']>;
};

export type DataReceiptItem = {
  __typename?: 'DataReceiptItem';
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reservationLineNo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DeleteBookingGiftCardResponse = GroupBookingResponseModel | ProblemDetails;

export type DeleteBookingItemsResponse = GroupBookingResponseModel | ProblemDetails;

export type DeleteMyBookingBookingResponse = JsonContainer | ProblemDetails;

export enum EnumsRequestDomain {
  Activity = 'activity',
  Hotel = 'hotel'
}

export type ErrorObject = {
  __typename?: 'ErrorObject';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type GiftCardCreateGiftCardResponse = {
  __typename?: 'GiftCardCreateGiftCardResponse';
  giftCardNo?: Maybe<Scalars['String']['output']>;
};

export type GiftCardFinalizeGiftCardResponse = {
  __typename?: 'GiftCardFinalizeGiftCardResponse';
  giftCard?: Maybe<BookingFlowGiftCardOrderModel>;
};

export type GiftCardGetGiftCardResponse = {
  __typename?: 'GiftCardGetGiftCardResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  externalDocumentNo?: Maybe<Scalars['String']['output']>;
  giftCardName?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  reasonBlocked?: Maybe<Scalars['String']['output']>;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  recipientAddress2?: Maybe<Scalars['String']['output']>;
  recipientCountryCode?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientPhoneNumber?: Maybe<Scalars['String']['output']>;
  recipientPostCode?: Maybe<Scalars['String']['output']>;
  shippingAmount?: Maybe<Scalars['Float']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type GiftCardGiftCardTdsmCheckResponse = {
  __typename?: 'GiftCardGiftCardTdsmCheckResponse';
  acsInfo?: Maybe<AcsInfo>;
  giftCardNo?: Maybe<Scalars['String']['output']>;
};

export type GiftCardOrderGiftCardResponse = {
  __typename?: 'GiftCardOrderGiftCardResponse';
  acsInfo?: Maybe<AcsInfo>;
  giftCardNo?: Maybe<Scalars['String']['output']>;
  tdsmInfo?: Maybe<TdsmInfo>;
};

export type GiftCardRequestModelInput = {
  bookingId?: InputMaybe<Scalars['UUID']['input']>;
  giftCardNo?: InputMaybe<Scalars['String']['input']>;
};

export type GiftCardValidateGiftCardPaymentResponse = {
  __typename?: 'GiftCardValidateGiftCardPaymentResponse';
  giftCardNo?: Maybe<Scalars['String']['output']>;
};

export type GroupBookingResponseModel = {
  __typename?: 'GroupBookingResponseModel';
  bookings?: Maybe<Array<Maybe<BookingResponseModel>>>;
  channelId?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<CustomerResponseModel>;
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  groupBookingRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  paymentStatus?: Maybe<PaymentStateEnum>;
  toBePaid?: Maybe<Scalars['Float']['output']>;
  totalDiscountedPrice?: Maybe<Scalars['Float']['output']>;
  /** Total accumualted price of all bookings */
  totalPrice?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type GuestClassificationModel = {
  __typename?: 'GuestClassificationModel';
  /** Guest classification description */
  description?: Maybe<Scalars['String']['output']>;
  /** Guest classification Id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Guest classification type */
  type?: Maybe<Scalars['String']['output']>;
};

export type HighlandbaseMutation = {
  __typename?: 'HighlandbaseMutation';
  Booking: BookingMutation;
};

export type HighlandbaseQuery = {
  __typename?: 'HighlandbaseQuery';
  Booking: BookingQuery;
};

export type HotelCartConfirmCartModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  children?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  otherGuests?: InputMaybe<Array<InputMaybe<HotelCartConfirmOtherGuestModelInput>>>;
  payment?: InputMaybe<HotelReservationPaymentModelInput>;
  primaryGuest?: InputMaybe<HotelCartConfirmGuestModelInput>;
};

export type HotelCartConfirmGuestAddressModelInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
};

export type HotelCartConfirmGuestModelInput = {
  address?: InputMaybe<HotelCartConfirmGuestAddressModelInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
};

export type HotelCartConfirmOtherGuestModelInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type HotelCartDtoHotelCartCustomerData = {
  __typename?: 'HotelCartDtoHotelCartCustomerData';
  otherGuests?: Maybe<Array<Maybe<HotelCartDtoHotelCustomerData>>>;
  primaryGuest?: Maybe<HotelCartDtoHotelCustomerData>;
};

export type HotelCartDtoHotelCartData = {
  __typename?: 'HotelCartDtoHotelCartData';
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<HotelCartDtoHotelCartCustomerData>;
  discountedAmount?: Maybe<Scalars['Float']['output']>;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  expirationLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  giftCards?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  items?: Maybe<Array<Maybe<HotelCartDtoHotelCartItemData>>>;
  membershipToken?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentRequired?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type HotelCartDtoHotelCartItemData = {
  __typename?: 'HotelCartDtoHotelCartItemData';
  discountedPrice?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fixedDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linePrice?: Maybe<Scalars['Float']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  totalLinePrice?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HotelCartDtoHotelCustomerData = {
  __typename?: 'HotelCartDtoHotelCustomerData';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

export type HotelCartDtoHotelReservation = {
  __typename?: 'HotelCartDtoHotelReservation';
  activities?: Maybe<Array<Maybe<HotelCartDtoHotelReservationActivityLine>>>;
  adults?: Maybe<Scalars['Int']['output']>;
  arrival?: Maybe<Scalars['DateTime']['output']>;
  children?: Maybe<Scalars['Int']['output']>;
  departure?: Maybe<Scalars['DateTime']['output']>;
  externalReservationNo?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Array<Maybe<HotelCartDtoHotelReservationExtra>>>;
  groupReservationNo?: Maybe<Scalars['String']['output']>;
  property?: Maybe<HotelEnumsHotelProperty>;
  rateCode?: Maybe<Scalars['String']['output']>;
  reservationNo?: Maybe<Scalars['String']['output']>;
  roomType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<HotelEnumsHotelStatus>;
};

export type HotelCartDtoHotelReservationActivityLine = {
  __typename?: 'HotelCartDtoHotelReservationActivityLine';
  amount?: Maybe<Scalars['Float']['output']>;
  bookingRef?: Maybe<Scalars['String']['output']>;
  clientNo?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  lineNo?: Maybe<Scalars['String']['output']>;
  numberOfAdults?: Maybe<Scalars['Int']['output']>;
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  numberOfPersons?: Maybe<Scalars['Int']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  productNo?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reservationDate?: Maybe<Scalars['DateTime']['output']>;
  showAvailability?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subStatus?: Maybe<Scalars['String']['output']>;
};

export type HotelCartDtoHotelReservationExtra = {
  __typename?: 'HotelCartDtoHotelReservationExtra';
  description?: Maybe<Scalars['String']['output']>;
  discountPct?: Maybe<Scalars['Float']['output']>;
  lineNo?: Maybe<Scalars['String']['output']>;
  numberOfPersons?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reservationNo?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type HotelCartDtoHotelRoomTypeAvailability = {
  __typename?: 'HotelCartDtoHotelRoomTypeAvailability';
  allowedAdults?: Maybe<Scalars['Int']['output']>;
  allowedChildren?: Maybe<Scalars['Int']['output']>;
  allowedGuests?: Maybe<Scalars['Int']['output']>;
  allowedInfants?: Maybe<Scalars['Int']['output']>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  available?: Maybe<Scalars['Int']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  lengthOfStay?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  rateCodes?: Maybe<Scalars['JSON']['output']>;
};

export type HotelCartHotelAvailabilityRangeResponse = {
  __typename?: 'HotelCartHotelAvailabilityRangeResponse';
  availabilities?: Maybe<Array<Maybe<HotelCartHotelRangeAvailability>>>;
  dates?: Maybe<Array<Maybe<HotelCartHotelRangeAllowedDate>>>;
};

export type HotelCartHotelAvailabilityResponse = {
  __typename?: 'HotelCartHotelAvailabilityResponse';
  availability?: Maybe<Array<Maybe<HotelCartDtoHotelRoomTypeAvailability>>>;
};

export type HotelCartHotelAvailableDateRange = {
  __typename?: 'HotelCartHotelAvailableDateRange';
  from?: Maybe<Scalars['Date']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
};

export type HotelCartHotelCartCheckoutResponse = {
  __typename?: 'HotelCartHotelCartCheckoutResponse';
  hotelConfirmationCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hotelGroupConfirmationCode?: Maybe<Scalars['String']['output']>;
  reservations?: Maybe<Array<Maybe<HotelCartDtoHotelReservation>>>;
};

export type HotelCartHotelCartStoreCustomerResponse = {
  __typename?: 'HotelCartHotelCartStoreCustomerResponse';
  cart?: Maybe<HotelCartDtoHotelCartData>;
};

export type HotelCartHotelCartTransactionResponse = {
  __typename?: 'HotelCartHotelCartTransactionResponse';
  cart?: Maybe<HotelCartDtoHotelCartData>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type HotelCartHotelRangeAllowedDate = {
  __typename?: 'HotelCartHotelRangeAllowedDate';
  maxDate?: Maybe<Scalars['DateTime']['output']>;
  rateCode?: Maybe<Scalars['String']['output']>;
};

export type HotelCartHotelRangeAvailability = {
  __typename?: 'HotelCartHotelRangeAvailability';
  availableRooms?: Maybe<Scalars['Int']['output']>;
  blockedRooms?: Maybe<Scalars['Int']['output']>;
  channelMgtOffset?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  property?: Maybe<HotelEnumsHotelProperty>;
  roomType?: Maybe<Scalars['String']['output']>;
  sellThreshold?: Maybe<Scalars['Int']['output']>;
  totalRooms?: Maybe<Scalars['Int']['output']>;
  validArrivalDate?: Maybe<Scalars['Boolean']['output']>;
  validDepartureDate?: Maybe<Scalars['Boolean']['output']>;
};

export type HotelCartHotelRestrictionsResponse = {
  __typename?: 'HotelCartHotelRestrictionsResponse';
  propertyRestriction?: Maybe<Scalars['JSON']['output']>;
  rateCodeRestriction?: Maybe<Scalars['JSON']['output']>;
  roomTypeRestriction?: Maybe<Scalars['JSON']['output']>;
};

export type HotelCartHotelUnavailabilityRangeResponse = {
  __typename?: 'HotelCartHotelUnavailabilityRangeResponse';
  checkoutOnlyDays: Array<Maybe<Scalars['Date']['output']>>;
  disabledDays: Array<Maybe<Scalars['Date']['output']>>;
  firstAvailableDateRange?: Maybe<HotelCartHotelAvailableDateRange>;
};

export type HotelCartRoomAvailabilityModelInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  enforceRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfNights?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rateCode?: InputMaybe<Scalars['String']['input']>;
};

export type HotelCartRoomAvailabilityRangeModelInput = {
  availableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  enforceRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  property?: InputMaybe<HotelEnumsHotelProperty>;
  rateCode?: InputMaybe<Scalars['String']['input']>;
  roomType?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HotelCartRoomAvailabilityWithSummarizedOffersModelInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfNights?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HotelCartRoomUnavailabilityRangeModelInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfNights?: InputMaybe<Scalars['Int']['input']>;
  property: HotelEnumsHotelProperty;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HotelCartStoreCustomerCartModelInput = {
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  otherGuests?: InputMaybe<Array<InputMaybe<HotelCartConfirmOtherGuestModelInput>>>;
  primaryGuest?: InputMaybe<HotelCartConfirmGuestModelInput>;
};

export enum HotelEnumsHotelBookingRestrictionType {
  ClosedArrival = 'ClosedArrival',
  ClosedDeparture = 'ClosedDeparture',
  MaxLeadDays = 'MaxLeadDays',
  MaxLos = 'MaxLos',
  MinLeadDays = 'MinLeadDays',
  MinLos = 'MinLos',
  OversellLimitProperty = 'OversellLimitProperty',
  OversellLimitRoomType = 'OversellLimitRoomType',
  SellLimit = 'SellLimit',
  Stop = 'Stop',
  Undersell = 'Undersell',
  UndersellLimitProperty = 'UndersellLimitProperty',
  Unknown = 'Unknown'
}

export enum HotelEnumsHotelPostingPattern {
  Daily = 'Daily',
  OnArrival = 'OnArrival',
  OnDeparture = 'OnDeparture',
  Reservation = 'Reservation'
}

export enum HotelEnumsHotelProperty {
  Kerlingarfjoll = 'KERLINGARFJOLL',
  Retreat = 'RETREAT',
  Silica = 'SILICA',
  Thjorsardalur = 'THJORSARDALUR',
  Unknown = 'UNKNOWN'
}

export enum HotelEnumsHotelStatus {
  Cancelled = 'CANCELLED',
  Checkedout = 'CHECKEDOUT',
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT',
  Inhouse = 'INHOUSE',
  None = 'NONE',
  Noshow = 'NOSHOW',
  PendingApproval = 'PENDING_APPROVAL',
  Unknown = 'UNKNOWN'
}

export type HotelPaymentChargeForGroupHotelTaskRequestInput = {
  groupBookingRef?: InputMaybe<Scalars['String']['input']>;
  linesPerBooking?: InputMaybe<Scalars['JSON']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type HotelPaymentChargeForHotelTaskRequestInput = {
  lineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type HotelPaymentChargePaymentTokenRequestInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  multiToken?: InputMaybe<Scalars['String']['input']>;
  noException?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  storePaymentLog?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HotelPaymentCloseHotelPaymentTaskRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type HotelPaymentCollectHotelBookingTaskLinesRequestInput = {
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type HotelPaymentGetPaymentTokenRequestInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type HotelPaymentHotelTaskDtoInput = {
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

export type HotelPaymentListHotelBookingTasksRequestInput = {
  filterText?: InputMaybe<Scalars['String']['input']>;
  hotelProperty?: InputMaybe<HotelEnumsHotelProperty>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  requestId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type HotelPaymentOpenHotelPaymentTaskRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type HotelRateCodeGetRateCodeResponse = {
  __typename?: 'HotelRateCodeGetRateCodeResponse';
  errorCode?: Maybe<Scalars['Int']['output']>;
  errorResp?: Maybe<Scalars['String']['output']>;
  rateCodes?: Maybe<Array<Maybe<HotelRateCodeHotelRateCode>>>;
};

export type HotelRateCodeHotelRateCode = {
  __typename?: 'HotelRateCodeHotelRateCode';
  cancellationDays?: Maybe<Scalars['Int']['output']>;
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  cancellationPolicyDescription?: Maybe<Scalars['String']['output']>;
  depositPolicy?: Maybe<Scalars['String']['output']>;
  depositPolicyDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  housekeepingRule?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rateCode?: Maybe<Scalars['String']['output']>;
  webEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HotelReservationBookingLine = {
  __typename?: 'HotelReservationBookingLine';
  isCharged?: Maybe<Scalars['Boolean']['output']>;
  lineNo?: Maybe<Scalars['String']['output']>;
};

export type HotelReservationCreateHotelReservationAttachmentRequestInput = {
  fileContent?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  reservationNo?: InputMaybe<Scalars['String']['input']>;
};

export type HotelReservationCreateHotelReservationAttachmentResponse = {
  __typename?: 'HotelReservationCreateHotelReservationAttachmentResponse';
  attachmentCreated?: Maybe<Scalars['Boolean']['output']>;
};

export type HotelReservationGetHotelChargeInfoResponse = {
  __typename?: 'HotelReservationGetHotelChargeInfoResponse';
  bookingLines?: Maybe<Array<Maybe<HotelReservationBookingLine>>>;
};

export type HotelReservationGuestRegistrationContractFinalizeGuestRegistrationRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  isOpted?: InputMaybe<Scalars['Boolean']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  reservationNo?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type HotelReservationGuestRegistrationContractFinalizeGuestRegistrationResponse = {
  __typename?: 'HotelReservationGuestRegistrationContractFinalizeGuestRegistrationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HotelReservationGuestRegistrationContractGetGuestRegistrationResponse = {
  __typename?: 'HotelReservationGuestRegistrationContractGetGuestRegistrationResponse';
  arrival?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  departure?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  guests?: Maybe<Scalars['Int']['output']>;
  nights?: Maybe<Scalars['Int']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  status?: Maybe<HotelReservationGuestRegistrationContractGuestRegistrationStatus>;
  street?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type HotelReservationGuestRegistrationContractGuestRegistrationStatus = {
  __typename?: 'HotelReservationGuestRegistrationContractGuestRegistrationStatus';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  inProgress?: Maybe<Scalars['Boolean']['output']>;
  preCheckin?: Maybe<Scalars['Boolean']['output']>;
};

export type HotelReservationGuestRegistrationContractSetGuestRegistrationContractRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  reservationNo?: InputMaybe<Scalars['String']['input']>;
  signatureNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type HotelReservationPaymentModelInput = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cvc?: InputMaybe<Scalars['String']['input']>;
  expireMonth?: InputMaybe<Scalars['String']['input']>;
  expireYear?: InputMaybe<Scalars['String']['input']>;
  isPlanet?: InputMaybe<Scalars['Boolean']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type HotelReservationReservationExtra = {
  __typename?: 'HotelReservationReservationExtra';
  bookingRef?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPct?: Maybe<Scalars['Float']['output']>;
  itemNo?: Maybe<Scalars['String']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  noOfPersons?: Maybe<Scalars['Int']['output']>;
  perGuest?: Maybe<Scalars['Boolean']['output']>;
  postingPattern?: Maybe<HotelEnumsHotelPostingPattern>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type HotelRestrictionRestrictionType = {
  __typename?: 'HotelRestrictionRestrictionType';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<HotelEnumsHotelBookingRestrictionType>;
};

export type HotelRestrictionRestrictionTypeResponse = {
  __typename?: 'HotelRestrictionRestrictionTypeResponse';
  restrictionTypes?: Maybe<Array<Maybe<HotelRestrictionRestrictionType>>>;
};

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type HttpValidationProblemDetails = {
  __typename?: 'HttpValidationProblemDetails';
  additionalProperties?: Maybe<Scalars['JSON']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type JsonContainer = {
  __typename?: 'JsonContainer';
  json?: Maybe<Scalars['JSON']['output']>;
};

export type McpPaymentModelInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  retrievalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipListMembershipProductsResponse = {
  __typename?: 'MembershipListMembershipProductsResponse';
  products?: Maybe<Array<Maybe<MembershipMembershipProduct>>>;
};

export type MembershipMembershipFinalizePaymentResponse = {
  __typename?: 'MembershipMembershipFinalizePaymentResponse';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  cardHolder?: Maybe<MembershipsContactData>;
  cardHolder2?: Maybe<MembershipsContactData>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MembershipMembershipInitTransactionResponse = {
  __typename?: 'MembershipMembershipInitTransactionResponse';
  membershipId?: Maybe<Scalars['Int']['output']>;
  paymentTransactionId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MembershipMembershipProduct = {
  __typename?: 'MembershipMembershipProduct';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type MembershipMembershipTdsmCheckResponse = {
  __typename?: 'MembershipMembershipTdsmCheckResponse';
  acsInfo?: Maybe<AcsInfo>;
  membershipRef?: Maybe<Scalars['String']['output']>;
};

export type MembershipOrderMembershipResponse = {
  __typename?: 'MembershipOrderMembershipResponse';
  acsInfo?: Maybe<AcsInfo>;
  membershipRef?: Maybe<Scalars['String']['output']>;
  tdsmInfo?: Maybe<TdsmInfo>;
};

export type MembershipValidateMembershipEmailResponse = {
  __typename?: 'MembershipValidateMembershipEmailResponse';
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type MembershipValidateMembershipPaymentResponse = {
  __typename?: 'MembershipValidateMembershipPaymentResponse';
  membershipRef?: Maybe<Scalars['String']['output']>;
};

export type MembershipValidateMembershipPhoneNumberResponse = {
  __typename?: 'MembershipValidateMembershipPhoneNumberResponse';
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type MembershipValidateMembershipSmsCodeResponse = {
  __typename?: 'MembershipValidateMembershipSmsCodeResponse';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipValidationToken?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfCardHolders?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type MembershipsContactData = {
  __typename?: 'MembershipsContactData';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  personalId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftAspNetCoreMvcProblemDetails = {
  __typename?: 'MicrosoftAspNetCoreMvcProblemDetails';
  additionalProperties?: Maybe<Scalars['JSON']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  Bluelagoon: BluelagoonMutation;
  Highlandbase: HighlandbaseMutation;
  TerkBooking: TerkBookingMutation;
};

export type MyBookingActivityProductUpgradeModel = {
  __typename?: 'MyBookingActivityProductUpgradeModel';
  amount?: Maybe<Scalars['Int']['output']>;
  upgradeFrom?: Maybe<Scalars['String']['output']>;
  upgradeFromDescription?: Maybe<Scalars['String']['output']>;
  upgradeTo?: Maybe<Scalars['String']['output']>;
  upgradeToDescription?: Maybe<Scalars['String']['output']>;
};

export type MyBookingActivityRefundInfo = {
  __typename?: 'MyBookingActivityRefundInfo';
  activityId?: Maybe<Scalars['String']['output']>;
  availableRefundPercentage?: Maybe<Scalars['Float']['output']>;
  depositedAmount?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  lineNumber?: Maybe<Scalars['String']['output']>;
  timeInHours?: Maybe<Scalars['Int']['output']>;
};

export type MyBookingAddActivityLineResponse = {
  __typename?: 'MyBookingAddActivityLineResponse';
  activityLines?: Maybe<Array<Maybe<BcActivityLine>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingAddActivityModelInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  numberOfPersons?: InputMaybe<Scalars['Int']['input']>;
  productNo?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reservationDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MyBookingAddBusTransferResponse = {
  __typename?: 'MyBookingAddBusTransferResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingAddHotelCommentModelInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MyBookingAddRetailItemModelInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  productNo?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MyBookingAddRetailItemResponse = {
  __typename?: 'MyBookingAddRetailItemResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  myBookingInfo?: Maybe<MyBookingMyBookingInfoModel>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingAvailableRefundModelInput = {
  domain?: InputMaybe<EnumsRequestDomain>;
};

export type MyBookingBusTransferChangeDataInput = {
  adultPrice?: InputMaybe<Scalars['Int']['input']>;
  departureDate?: InputMaybe<Scalars['DateTime']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  dropoffLocationId?: InputMaybe<Scalars['String']['input']>;
  pickupLocationId?: InputMaybe<Scalars['String']['input']>;
  pickupTime?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingCancelActivityLineResponse = {
  __typename?: 'MyBookingCancelActivityLineResponse';
  activityLines?: Maybe<Array<Maybe<BcActivityLine>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingCancelBookingModelInput = {
  hotelReservationNo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MyBookingCancelMyBookingPaymentResponse = {
  __typename?: 'MyBookingCancelMyBookingPaymentResponse';
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MyBookingCancelTransactionModelInput = {
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingChangeDateTimeRequestDtoInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalTime?: InputMaybe<Scalars['String']['input']>;
  busTransfer?: InputMaybe<MyBookingBusTransferChangeDataInput>;
};

export type MyBookingChangePasswordRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingChangePasswordResponse = {
  __typename?: 'MyBookingChangePasswordResponse';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingCreateOrUpdateUserRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingCreateOrUpdateUserResponse = {
  __typename?: 'MyBookingCreateOrUpdateUserResponse';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingExtraRefundInfo = {
  __typename?: 'MyBookingExtraRefundInfo';
  availableRefundPercentage?: Maybe<Scalars['Float']['output']>;
  depositedAmount?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  extraId?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['String']['output']>;
  timeInHours?: Maybe<Scalars['Int']['output']>;
};

export type MyBookingFinalizeTransactionModelInput = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingGetActivityLinesResponse = {
  __typename?: 'MyBookingGetActivityLinesResponse';
  activityLines?: Maybe<Array<Maybe<BcActivityLine>>>;
};

export type MyBookingGetAllBookingsRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingGetAllBookingsResponse = {
  __typename?: 'MyBookingGetAllBookingsResponse';
  bookings?: Maybe<Array<Maybe<AgentBookingBookingInfoData>>>;
};

export type MyBookingHotelActivityRefundInfoResponse = {
  __typename?: 'MyBookingHotelActivityRefundInfoResponse';
  activityRefundInfo?: Maybe<Array<Maybe<MyBookingActivityRefundInfo>>>;
};

export type MyBookingHotelAddActivitiesToHotelResponse = {
  __typename?: 'MyBookingHotelAddActivitiesToHotelResponse';
  result?: Maybe<Array<Maybe<MyBookingHotelAddActivityResult>>>;
};

export type MyBookingHotelAddActivityResult = {
  __typename?: 'MyBookingHotelAddActivityResult';
  bookingRef?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingHotelAddReservationExtraResult = {
  __typename?: 'MyBookingHotelAddReservationExtraResult';
  bookingRef?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingHotelAddReservationExtrasToHotelResponse = {
  __typename?: 'MyBookingHotelAddReservationExtrasToHotelResponse';
  result?: Maybe<Array<Maybe<MyBookingHotelAddReservationExtraResult>>>;
};

export type MyBookingHotelExtraRefundInfoResponse = {
  __typename?: 'MyBookingHotelExtraRefundInfoResponse';
  extraRefundInfo?: Maybe<Array<Maybe<MyBookingExtraRefundInfo>>>;
};

export type MyBookingHotelInitializeHotelPaymentTokenRequestInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingHotelInitializeHotelPaymentTokenResponse = {
  __typename?: 'MyBookingHotelInitializeHotelPaymentTokenResponse';
  maskedCard?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MyBookingHotelMyBookingHotelLoginResponse = {
  __typename?: 'MyBookingHotelMyBookingHotelLoginResponse';
  pending?: Maybe<Scalars['Boolean']['output']>;
  reservations?: Maybe<Array<Maybe<MyBookingHotelReservationModel>>>;
};

export type MyBookingHotelReservationExtraInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  itemNo?: InputMaybe<Scalars['String']['input']>;
  lineNo?: InputMaybe<Scalars['Int']['input']>;
  noOfPersons?: InputMaybe<Scalars['Int']['input']>;
  perGuest?: InputMaybe<Scalars['Boolean']['input']>;
  postingPattern?: InputMaybe<HotelEnumsHotelPostingPattern>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type MyBookingHotelReservationModel = {
  __typename?: 'MyBookingHotelReservationModel';
  activities?: Maybe<Array<Maybe<BcActivityLine>>>;
  actualCheckInTime?: Maybe<Scalars['String']['output']>;
  actualCheckOutTime?: Maybe<Scalars['String']['output']>;
  adults?: Maybe<Scalars['Int']['output']>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  bookedRoomType?: Maybe<Scalars['String']['output']>;
  cancellationDateTime?: Maybe<Scalars['String']['output']>;
  cancellationNo?: Maybe<Scalars['String']['output']>;
  checkInTime?: Maybe<Scalars['String']['output']>;
  checkOutTime?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contactName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cribs?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalReservationNo?: Maybe<Scalars['String']['output']>;
  extraBeds?: Maybe<Scalars['Int']['output']>;
  extras?: Maybe<Array<Maybe<HotelReservationReservationExtra>>>;
  groupReservationNo?: Maybe<Scalars['String']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  guestNo?: Maybe<Scalars['String']['output']>;
  mobilePhoneNo?: Maybe<Scalars['String']['output']>;
  nights?: Maybe<Scalars['Int']['output']>;
  numChildren?: Maybe<Scalars['Int']['output']>;
  numInfants?: Maybe<Scalars['Int']['output']>;
  payingRoomType?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  property?: Maybe<HotelEnumsHotelProperty>;
  rateCode?: Maybe<Scalars['String']['output']>;
  reservationNo?: Maybe<Scalars['String']['output']>;
  roomType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<HotelEnumsHotelStatus>;
};

export type MyBookingMyBookingActivityData = {
  __typename?: 'MyBookingMyBookingActivityData';
  bookingId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  lineNo?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reservationDate?: Maybe<Scalars['DateTime']['output']>;
  reservationTime?: Maybe<Scalars['DateTime']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type MyBookingMyBookingAddedProductData = {
  __typename?: 'MyBookingMyBookingAddedProductData';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
};

export type MyBookingMyBookingBusTransferData = {
  __typename?: 'MyBookingMyBookingBusTransferData';
  adultPrice?: Maybe<Scalars['Int']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  departureTime?: Maybe<Scalars['String']['output']>;
  dropoffLocationId?: Maybe<Scalars['String']['output']>;
  dropoffLocationName?: Maybe<Scalars['String']['output']>;
  pickupLocationId?: Maybe<Scalars['String']['output']>;
  pickupLocationName?: Maybe<Scalars['String']['output']>;
  pickupTime?: Maybe<Scalars['String']['output']>;
};

export type MyBookingMyBookingBusTransferModelInput = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  adultPrice?: InputMaybe<Scalars['Int']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  departureDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  dropoffLocationId?: InputMaybe<Scalars['String']['input']>;
  pickupDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  pickupLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingMyBookingCustomerData = {
  __typename?: 'MyBookingMyBookingCustomerData';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MyBookingMyBookingFinalizePaymentResponse = {
  __typename?: 'MyBookingMyBookingFinalizePaymentResponse';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MyBookingMyBookingGetTransactionsResponse = {
  __typename?: 'MyBookingMyBookingGetTransactionsResponse';
  payments?: Maybe<Array<Maybe<MyBookingMyBookingPayment>>>;
};

export type MyBookingMyBookingHotelRoomModelInput = {
  bookingDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  bookingDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  rateCode?: InputMaybe<Scalars['String']['input']>;
  reservationNo?: InputMaybe<Scalars['String']['input']>;
  roomType?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingMyBookingInfoModel = {
  __typename?: 'MyBookingMyBookingInfoModel';
  activities?: Maybe<Array<Maybe<MyBookingMyBookingActivityData>>>;
  adultCount?: Maybe<Scalars['Int']['output']>;
  adultPrice?: Maybe<Scalars['Float']['output']>;
  agentBookingRef?: Maybe<Scalars['String']['output']>;
  agentInitials?: Maybe<Scalars['String']['output']>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  arrivalTime?: Maybe<Scalars['DateTime']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['String']['output']>;
  busTransfer?: Maybe<MyBookingMyBookingBusTransferData>;
  childrenCount?: Maybe<Scalars['Int']['output']>;
  childrenPrice?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<MyBookingMyBookingCustomerData>;
  hasMcpTransaction?: Maybe<Scalars['Boolean']['output']>;
  massage?: Maybe<Array<Maybe<MyBookingMyBookingMassageData>>>;
  packageType?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<MyBookingMyBookingAddedProductData>>>;
  promoCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tableReservation?: Maybe<MyBookingMyBookingTableReservationData>;
  teenagerCount?: Maybe<Scalars['Int']['output']>;
  teenagerPrice?: Maybe<Scalars['Float']['output']>;
  timeFrom?: Maybe<Scalars['String']['output']>;
  timeTo?: Maybe<Scalars['String']['output']>;
  walletPassId?: Maybe<Scalars['String']['output']>;
};

export type MyBookingMyBookingInitTransactionModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingMyBookingInitTransactionResponse = {
  __typename?: 'MyBookingMyBookingInitTransactionResponse';
  paymentTransactionId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MyBookingMyBookingLoginWithPasswordRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingMyBookingMassageData = {
  __typename?: 'MyBookingMyBookingMassageData';
  guests?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type MyBookingMyBookingPayment = {
  __typename?: 'MyBookingMyBookingPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  authorized?: Maybe<Scalars['Boolean']['output']>;
  bookingRef?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MyBookingMyBookingTableReservationData = {
  __typename?: 'MyBookingMyBookingTableReservationData';
  arrivalTime?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  guests?: Maybe<Scalars['Int']['output']>;
};

export type MyBookingPassSourceRequestModelInput = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  passId?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingPassSourceResponseModel = {
  __typename?: 'MyBookingPassSourceResponseModel';
  applePassData?: Maybe<Scalars['Byte']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type MyBookingRequestModelInput = {
  /** Booking reference */
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingResetPasswordRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  resetToken?: InputMaybe<Scalars['UUID']['input']>;
};

export type MyBookingResetPasswordResponse = {
  __typename?: 'MyBookingResetPasswordResponse';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingResponseModel = {
  __typename?: 'MyBookingResponseModel';
  /** Name on booking */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Access token */
  token?: Maybe<Scalars['String']['output']>;
};

export type MyBookingSendPasswordResetEmailRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingSendPasswordResetEmailResponse = {
  __typename?: 'MyBookingSendPasswordResetEmailResponse';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingUpdateActivityLineResponse = {
  __typename?: 'MyBookingUpdateActivityLineResponse';
  activityLines?: Maybe<Array<Maybe<BcActivityLine>>>;
  errorMessage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  partialSuccess?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingUpdateActivityModelInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  lineNo?: InputMaybe<Scalars['String']['input']>;
  numberOfPersons?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reservationDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MyBookingUpdateBusTransferResponse = {
  __typename?: 'MyBookingUpdateBusTransferResponse';
  bookingRef?: Maybe<Scalars['String']['output']>;
  departureDateTime?: Maybe<Scalars['DateTime']['output']>;
  dropoffLocationId?: Maybe<Scalars['String']['output']>;
  pickupDateTime?: Maybe<Scalars['DateTime']['output']>;
  pickupLocationId?: Maybe<Scalars['String']['output']>;
};

export type MyBookingUpdateHotelRoomResponseModel = {
  __typename?: 'MyBookingUpdateHotelRoomResponseModel';
  reservations?: Maybe<Array<Maybe<MyBookingHotelReservationModel>>>;
};

export type MyBookingUpdatePaymentTokenModelInput = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  reservations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingUpgradeActivityLineResponse = {
  __typename?: 'MyBookingUpgradeActivityLineResponse';
  activityLines?: Maybe<Array<Maybe<BcActivityLine>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MyBookingUpgradeActivityModelInput = {
  lineNo?: InputMaybe<Scalars['String']['input']>;
  productNo?: InputMaybe<Scalars['String']['input']>;
  reservationDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NewBookingItemRequestModelInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['NonEmptyString']['input'];
  quantity: Scalars['Int']['input'];
};

export type NewBookingRequestModelInput = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  groupBookingId?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<InputMaybe<NewBookingItemRequestModelInput>>>;
  salesLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type NewSingleBookingItemRequestModelInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['NonEmptyString']['input'];
  quantity: Scalars['Int']['input'];
};

export type NewSingleBookingRequestModelInput = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<InputMaybe<NewSingleBookingItemRequestModelInput>>>;
  salesLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentPaymentTdsmRequestModelInput = {
  paymentId: Scalars['NonEmptyString']['input'];
};

export type PaymentPaymentValidateRequestModelInput = {
  cres?: InputMaybe<Scalars['String']['input']>;
  pares?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['NonEmptyString']['input'];
};

export type PaymentPlanetAliasCardInfo = {
  __typename?: 'PaymentPlanetAliasCardInfo';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetAuthorizeAuthenticatedTransactionModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  autoSettle?: InputMaybe<Scalars['Boolean']['input']>;
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  businessProcess?: InputMaybe<BlLsRetailODataPlanetEnumsTransactionBusinessProcess>;
  keepToken?: InputMaybe<Scalars['Boolean']['input']>;
  mcp?: InputMaybe<PaymentPlanetInitPaymentMcpModelInput>;
  origin?: InputMaybe<BlLsRetailODataPlanetEnumsPaymentChannel>;
  refNo2?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetAuthorizeAuthenticatedTransactionResponse = {
  __typename?: 'PaymentPlanetAuthorizeAuthenticatedTransactionResponse';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  error?: Maybe<PaymentPlanetPlanetError>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetCancelPaymentModelInput = {
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetChargeTokenResponse = {
  __typename?: 'PaymentPlanetChargeTokenResponse';
  authCode?: Maybe<Scalars['String']['output']>;
  maskedCard?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetCollectCurrencyConversionRatesResponse = {
  __typename?: 'PaymentPlanetCollectCurrencyConversionRatesResponse';
  conversionRates?: Maybe<PaymentPlanetCurrencyConversion>;
};

export type PaymentPlanetCurrencyConversion = {
  __typename?: 'PaymentPlanetCurrencyConversion';
  rates?: Maybe<Array<Maybe<PaymentPlanetCurrencyConversionRate>>>;
  reportDetail?: Maybe<PaymentPlanetCurrencyConversionDetail>;
  requestId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetCurrencyConversionDetail = {
  __typename?: 'PaymentPlanetCurrencyConversionDetail';
  retrievalReferenceNumber?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentPlanetCurrencyConversionRate = {
  __typename?: 'PaymentPlanetCurrencyConversionRate';
  currency?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
  roundUnit?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanetGetAliasInformationResponse = {
  __typename?: 'PaymentPlanetGetAliasInformationResponse';
  alias?: Maybe<Scalars['String']['output']>;
  card?: Maybe<PaymentPlanetAliasCardInfo>;
  created?: Maybe<Scalars['DateTime']['output']>;
  expiryMonth?: Maybe<Scalars['String']['output']>;
  expiryYear?: Maybe<Scalars['String']['output']>;
  masked?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetGetAliasResponse = {
  __typename?: 'PaymentPlanetGetAliasResponse';
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  masked?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetGetPaymentStatusResponse = {
  __typename?: 'PaymentPlanetGetPaymentStatusResponse';
  data?: Maybe<Array<Maybe<PaymentPlanetPaymentStatus>>>;
};

export type PaymentPlanetInitPaymentMcpModelInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  retrievalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetInitPaymentRedirectOptionModelInput = {
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  errorUrl?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  returnTarget?: InputMaybe<Scalars['String']['input']>;
  startTarget?: InputMaybe<Scalars['String']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetInitPaymentResponse = {
  __typename?: 'PaymentPlanetInitPaymentResponse';
  paymentTransactionId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetInitPaymentThemeOptionModelInput = {
  brandButton?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  initialView?: InputMaybe<Scalars['String']['input']>;
  logoBorderColor?: InputMaybe<Scalars['String']['input']>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  logoType?: InputMaybe<Scalars['String']['input']>;
  payButtonTextColor?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetInitSecureFieldsPaymentResponse = {
  __typename?: 'PaymentPlanetInitSecureFieldsPaymentResponse';
  paymentTransactionId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetInitializePaymentModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  autoSettle?: InputMaybe<Scalars['Boolean']['input']>;
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  businessProcess?: InputMaybe<BlLsRetailODataPlanetEnumsTransactionBusinessProcess>;
  keepToken?: InputMaybe<Scalars['Boolean']['input']>;
  mcp?: InputMaybe<PaymentPlanetInitPaymentMcpModelInput>;
  origin?: InputMaybe<BlLsRetailODataPlanetEnumsPaymentChannel>;
  redirectOption?: InputMaybe<PaymentPlanetInitPaymentRedirectOptionModelInput>;
  refNo2?: InputMaybe<Scalars['String']['input']>;
  themeOption?: InputMaybe<PaymentPlanetInitPaymentThemeOptionModelInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetInitializeSecureFieldsPaymentModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  autoSettle?: InputMaybe<Scalars['Boolean']['input']>;
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  businessProcess?: InputMaybe<BlLsRetailODataPlanetEnumsTransactionBusinessProcess>;
  keepToken?: InputMaybe<Scalars['Boolean']['input']>;
  mcp?: InputMaybe<PaymentPlanetInitPaymentMcpModelInput>;
  origin?: InputMaybe<BlLsRetailODataPlanetEnumsPaymentChannel>;
  refNo2?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetPayByLinkResponse = {
  __typename?: 'PaymentPlanetPayByLinkResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPaymentCard3DsModel = {
  __typename?: 'PaymentPlanetPaymentCard3DsModel';
  authenticationResponse?: Maybe<Scalars['String']['output']>;
  cardHolderInfo?: Maybe<Scalars['String']['output']>;
  transStatusReason?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPaymentCardInfoModel = {
  __typename?: 'PaymentPlanetPaymentCardInfoModel';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPaymentCardModel = {
  __typename?: 'PaymentPlanetPaymentCardModel';
  alias?: Maybe<Scalars['String']['output']>;
  expiryMonth?: Maybe<Scalars['String']['output']>;
  expiryYear?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  info?: Maybe<PaymentPlanetPaymentCardInfoModel>;
  masked?: Maybe<Scalars['String']['output']>;
  threeDs?: Maybe<PaymentPlanetPaymentCard3DsModel>;
};

export type PaymentPlanetPaymentDetailAuthModel = {
  __typename?: 'PaymentPlanetPaymentDetailAuthModel';
  acquirerAuthorizationCode?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanetPaymentDetailCreditModel = {
  __typename?: 'PaymentPlanetPaymentDetailCreditModel';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanetPaymentDetailFailModel = {
  __typename?: 'PaymentPlanetPaymentDetailFailModel';
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPaymentDetailInitModel = {
  __typename?: 'PaymentPlanetPaymentDetailInitModel';
  expires?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentPlanetPaymentDetailModel = {
  __typename?: 'PaymentPlanetPaymentDetailModel';
  authorize?: Maybe<PaymentPlanetPaymentDetailAuthModel>;
  credit?: Maybe<PaymentPlanetPaymentDetailCreditModel>;
  fail?: Maybe<PaymentPlanetPaymentDetailFailModel>;
  init?: Maybe<PaymentPlanetPaymentDetailInitModel>;
  settle?: Maybe<PaymentPlanetPaymentDetailSettleModel>;
};

export type PaymentPlanetPaymentDetailSettleModel = {
  __typename?: 'PaymentPlanetPaymentDetailSettleModel';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanetPaymentErrorResponse = {
  __typename?: 'PaymentPlanetPaymentErrorResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPaymentHistoryModel = {
  __typename?: 'PaymentPlanetPaymentHistoryModel';
  action?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentPlanetPaymentMultiCurrencyProcessingModel = {
  __typename?: 'PaymentPlanetPaymentMultiCurrencyProcessingModel';
  amount?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reasonIndicator?: Maybe<Scalars['String']['output']>;
  retrievalReferenceNumber?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPaymentStatus = {
  __typename?: 'PaymentPlanetPaymentStatus';
  amount?: Maybe<Scalars['Float']['output']>;
  data?: Maybe<PaymentPlanetPaymentStatusModel>;
  fullyRefunded?: Maybe<Scalars['Boolean']['output']>;
  refNo?: Maybe<Scalars['String']['output']>;
  refNo2?: Maybe<Scalars['String']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  refundedAmount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanetPaymentStatusModel = {
  __typename?: 'PaymentPlanetPaymentStatusModel';
  card?: Maybe<PaymentPlanetPaymentCardModel>;
  currency?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<PaymentPlanetPaymentDetailModel>;
  error?: Maybe<PaymentPlanetPaymentErrorResponse>;
  history?: Maybe<Array<Maybe<PaymentPlanetPaymentHistoryModel>>>;
  language?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  multiCurrencyProcessing?: Maybe<PaymentPlanetPaymentMultiCurrencyProcessingModel>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  refNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetPlanetError = {
  __typename?: 'PaymentPlanetPlanetError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanetRefundBookingModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  refundGiftCards?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentPlanetRefundPaymentModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentPlanetRefundPaymentResponse = {
  __typename?: 'PaymentPlanetRefundPaymentResponse';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  refundTransactionId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentPlanetUpdatePaymentModelInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bookingRef?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentRefundAndDepositResponse = {
  __typename?: 'PaymentRefundAndDepositResponse';
  refundSuccessful?: Maybe<Scalars['Boolean']['output']>;
  totalAmountRefunded?: Maybe<Scalars['Float']['output']>;
  totalAmountToRefund?: Maybe<Scalars['Float']['output']>;
};

export enum PaymentStateEnum {
  CardCheck = 'CardCheck',
  Declined = 'Declined',
  Initialized = 'Initialized',
  Invoiced = 'Invoiced',
  NoPayment = 'NoPayment',
  Paid = 'Paid',
  Partial = 'Partial',
  Unpaid = 'Unpaid'
}

export type PolicyConfigCurrentPolicyInfo = {
  __typename?: 'PolicyConfigCurrentPolicyInfo';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refundPolicyLines?: Maybe<Array<Maybe<PolicyConfigGetPolicyLines>>>;
  retreat?: Maybe<Scalars['Boolean']['output']>;
  storm?: Maybe<Scalars['Boolean']['output']>;
};

export type PolicyConfigGetPolicyLines = {
  __typename?: 'PolicyConfigGetPolicyLines';
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refundPercentage?: Maybe<Scalars['Float']['output']>;
  refundPolicyId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type PolicyConfigStormModelInput = {
  isStorm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostApiV1PaymentBookingRefundResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentRefundAndDepositResponse;

export type PostApiV1PaymentChargeTokenResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetChargeTokenResponse;

export type PostApiV1PaymentTransactionAuthorizeAuthenticatedResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetAuthorizeAuthenticatedTransactionResponse;

export type PostApiV1PaymentTransactionCancelResponse = JsonContainer | MicrosoftAspNetCoreMvcProblemDetails;

export type PostApiV1PaymentTransactionRefundResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetRefundPaymentResponse;

export type PostApiV1PaymentTransactionResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetInitPaymentResponse;

export type PostApiV1PaymentTransactionSecureFieldResponse = MicrosoftAspNetCoreMvcProblemDetails | PaymentPlanetInitSecureFieldsPaymentResponse;

export type PostApiV1PaymentTransactionSettleResponse = MicrosoftAspNetCoreMvcProblemDetails | VoidContainer;

export type PostApiV1PaymentValidateResponse = JsonContainer | MicrosoftAspNetCoreMvcProblemDetails;

export type PostBookingCheckoutResponse = GroupBookingResponseModel | ProblemDetails;

export type PostBookingCustomerResponse = GroupBookingResponseModel | ProblemDetails;

export type PostBookingGiftCardResponse = GroupBookingResponseModel | ProblemDetails;

export type PostBookingItemsResponse = GroupBookingResponseModel | ProblemDetails;

export type PostBookingNewResponse = GroupBookingResponseModel | ProblemDetails;

export type PostBookingPromoCodeResponse = GroupBookingResponseModel | ProblemDetails;

export type PostBookingTransactionResponse = CreateTransactionResponseModel | ProblemDetails;

export type PostMyBookingLoginResponse = MyBookingResponseModel | ProblemDetails;

export type PostProductsAvailabilityRequestInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type PostProductsAvailabilitySlotRequestInput = {
  /** Product ids to be processed */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sales location to be used */
  salesLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Timeslot being requested */
  timeSlot?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostProductsAvailabilitySlotResponse = HttpValidationProblemDetails | ProblemDetails | ProductAvailabilitySlotResponseModel;

export type PostProductsAvailableRequestInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type PostProductsAvailableResponse = HttpValidationProblemDetails | ProblemDetails | ProductAvailableModel;

export type PriceModel = {
  __typename?: 'PriceModel';
  /** Discount percentage that is applied to the Price property */
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  /** Item price with discounts and fixed pricing applied */
  discountPrice?: Maybe<Scalars['Float']['output']>;
  /** If true, pricing is dictated from the source system, else Price property is used */
  dynamicPricing?: Maybe<Scalars['Boolean']['output']>;
  /** FixedPrice overrides the Price property and the dynamic price from source system */
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  /** Shows the price of the product, per unit */
  price?: Maybe<Scalars['Float']['output']>;
};

export type ProblemDetails = {
  __typename?: 'ProblemDetails';
  additionalProperties?: Maybe<Scalars['JSON']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductAvailabilityModel = {
  __typename?: 'ProductAvailabilityModel';
  /** Total availability left */
  availability?: Maybe<Scalars['Int']['output']>;
  /** Channel Id */
  channelId?: Maybe<Scalars['Int']['output']>;
  /** Discount percentage applied to the ItemPrice */
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  /** Fixed price (overrides ItemPrice) if available */
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  /** Unit price for product */
  itemPrice?: Maybe<Scalars['Float']['output']>;
  /** Price with discounts applied */
  price?: Maybe<Scalars['Float']['output']>;
  /** Id of the product */
  productId?: Maybe<Scalars['String']['output']>;
  /** Sales location Id */
  salesLocationId?: Maybe<Scalars['Int']['output']>;
  /** Timeslot of the product */
  timeSlot?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductAvailabilitySlotModel = {
  __typename?: 'ProductAvailabilitySlotModel';
  availability?: Maybe<Scalars['Int']['output']>;
  /** Channel Id */
  channelId?: Maybe<Scalars['Int']['output']>;
  /** Discount percentage applied to the ItemPrice */
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  expires?: Maybe<Scalars['DateTime']['output']>;
  /** Fixed price (overrides ItemPrice) if available */
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  /** Unit price for product */
  itemPrice?: Maybe<Scalars['Float']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  /** Price with discounts applied */
  price?: Maybe<Scalars['Float']['output']>;
  /** Id of the product */
  productId?: Maybe<Scalars['String']['output']>;
  /** Sales location Id */
  salesLocationId?: Maybe<Scalars['Int']['output']>;
  timeSlot?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductAvailabilitySlotResponseModel = {
  __typename?: 'ProductAvailabilitySlotResponseModel';
  availability?: Maybe<Array<Maybe<ProductAvailabilitySlotModel>>>;
};

export type ProductAvailableModel = {
  __typename?: 'ProductAvailableModel';
  /** If true, there exists an availability for any of the requested products */
  isAvailabile?: Maybe<Scalars['Boolean']['output']>;
  /** Date of the availability */
  timeSlot?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductCatalogDtoProductData = {
  __typename?: 'ProductCatalogDtoProductData';
  availabilityBasedPricing?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  discountedPrice?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fixedDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  fixedNumberOfPersons?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maximumNumberOfPersons?: Maybe<Scalars['Int']['output']>;
  maximumQty?: Maybe<Scalars['Int']['output']>;
  maximumQtyPerLine?: Maybe<Scalars['Int']['output']>;
  minimumQty?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productSubType?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
  roomType?: Maybe<Scalars['String']['output']>;
  timeSlotLength?: Maybe<Scalars['Int']['output']>;
};

export type ProductCatalogDtoProductTypeData = {
  __typename?: 'ProductCatalogDtoProductTypeData';
  description?: Maybe<Scalars['String']['output']>;
  hasAvailability?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Array<Maybe<ProductCatalogDtoProductTypeMetaData>>>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductCatalogDtoProductTypeState>;
};

export type ProductCatalogDtoProductTypeMetaData = {
  __typename?: 'ProductCatalogDtoProductTypeMetaData';
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductCatalogDtoProductTypeState = {
  __typename?: 'ProductCatalogDtoProductTypeState';
  defaultState?: Maybe<BlLsRetailODataActivityServiceEnumsActivityStatus>;
  defaultStateOnDateUpdate?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductCatalogGetProductTypesResponse = {
  __typename?: 'ProductCatalogGetProductTypesResponse';
  productTypes?: Maybe<Array<Maybe<ProductCatalogDtoProductTypeData>>>;
};

export type ProductCatalogGetProductsResponse = {
  __typename?: 'ProductCatalogGetProductsResponse';
  products?: Maybe<Array<Maybe<ProductCatalogDtoProductData>>>;
};

export type ProductCatalogGetTransportLocationsResponse = {
  __typename?: 'ProductCatalogGetTransportLocationsResponse';
  locations?: Maybe<Array<Maybe<ProductCatalogLocation>>>;
};

export type ProductCatalogLocalConfigDtoLocalChannelConfigurationData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalChannelConfigurationData';
  hotelRegionName?: Maybe<Scalars['String']['output']>;
};

export type ProductCatalogLocalConfigDtoLocalChannelConfigurationDataInput = {
  hotelRegionName?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCatalogLocalConfigDtoLocalChannelData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalChannelData';
  allowAdditionalProducts?: Maybe<Scalars['Boolean']['output']>;
  configuration?: Maybe<ProductCatalogLocalConfigDtoLocalChannelConfigurationData>;
  excludeProductTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  excludeProducts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includeProductTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includeProducts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalProductData>>>;
  source?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subChannels?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalChannelData>>>;
};

export type ProductCatalogLocalConfigDtoLocalChannelDataInput = {
  allowAdditionalProducts?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<ProductCatalogLocalConfigDtoLocalChannelConfigurationDataInput>;
  excludeProductTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeProductTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<ProductCatalogLocalConfigDtoLocalProductDataInput>>>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subChannels?: InputMaybe<Array<InputMaybe<ProductCatalogLocalConfigDtoLocalChannelDataInput>>>;
};

export type ProductCatalogLocalConfigDtoLocalProductCatalogData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalProductCatalogData';
  channels?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalChannelData>>>;
  productTypes?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalProductTypeData>>>;
  systems?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalSystemData>>>;
};

export type ProductCatalogLocalConfigDtoLocalProductData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalProductData';
  availabilityBasedPricing?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fixedDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  fixedNumberOfPersons?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maximumNumberOfPersons?: Maybe<Scalars['Int']['output']>;
  maximumQty?: Maybe<Scalars['Int']['output']>;
  maximumQtyPerLine?: Maybe<Scalars['Int']['output']>;
  minimumQty?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productSubType?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
  roomType?: Maybe<Scalars['String']['output']>;
  timeSlotLength?: Maybe<Scalars['Int']['output']>;
};

export type ProductCatalogLocalConfigDtoLocalProductDataInput = {
  availabilityBasedPricing?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fixedDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  fixedNumberOfPersons?: InputMaybe<Scalars['Int']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maximumNumberOfPersons?: InputMaybe<Scalars['Int']['input']>;
  maximumQty?: InputMaybe<Scalars['Int']['input']>;
  maximumQtyPerLine?: InputMaybe<Scalars['Int']['input']>;
  minimumQty?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productSubType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  roomType?: InputMaybe<Scalars['String']['input']>;
  timeSlotLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCatalogLocalConfigDtoLocalProductTypeData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalProductTypeData';
  description?: Maybe<Scalars['String']['output']>;
  hasAvailability?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalProductTypeMetaData>>>;
  name: Scalars['NonEmptyString']['output'];
  status?: Maybe<ProductCatalogLocalConfigDtoLocalProductTypeStateData>;
};

export type ProductCatalogLocalConfigDtoLocalProductTypeDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hasAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Array<InputMaybe<ProductCatalogLocalConfigDtoLocalProductTypeMetaDataInput>>>;
  name: Scalars['NonEmptyString']['input'];
  status?: InputMaybe<ProductCatalogLocalConfigDtoLocalProductTypeStateDataInput>;
};

export type ProductCatalogLocalConfigDtoLocalProductTypeMetaData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalProductTypeMetaData';
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductCatalogLocalConfigDtoLocalProductTypeMetaDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCatalogLocalConfigDtoLocalProductTypeStateData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalProductTypeStateData';
  defaultState?: Maybe<BlLsRetailODataActivityServiceEnumsActivityStatus>;
  defaultStateOnDateUpdate?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductCatalogLocalConfigDtoLocalProductTypeStateDataInput = {
  defaultState?: InputMaybe<BlLsRetailODataActivityServiceEnumsActivityStatus>;
  defaultStateOnDateUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCatalogLocalConfigDtoLocalSystemData = {
  __typename?: 'ProductCatalogLocalConfigDtoLocalSystemData';
  company?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  name: Scalars['NonEmptyString']['output'];
  products?: Maybe<Array<Maybe<ProductCatalogLocalConfigDtoLocalProductData>>>;
};

export type ProductCatalogLocalConfigDtoLocalSystemDataInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['NonEmptyString']['input'];
  products?: InputMaybe<Array<InputMaybe<ProductCatalogLocalConfigDtoLocalProductDataInput>>>;
};

export type ProductCatalogLocation = {
  __typename?: 'ProductCatalogLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  componentId?: Maybe<Scalars['Int']['output']>;
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductCatalogLocationType>;
};

export enum ProductCatalogLocationType {
  Dropoff = 'DROPOFF',
  Pickup = 'PICKUP'
}

export type ProductCatalogSetRecommendedTransportLocationsResponse = {
  __typename?: 'ProductCatalogSetRecommendedTransportLocationsResponse';
  originalRecommendedLocationIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updatedRecommendedLocationIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ProductModel = {
  __typename?: 'ProductModel';
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** If not null, represents the fixed noOfPersons applied to the product */
  fixedNoOfPersons?: Maybe<Scalars['Int']['output']>;
  /** If not null, represents the fixed quantity applied to the product */
  fixedQuantity?: Maybe<Scalars['Int']['output']>;
  /** Product name */
  fullName?: Maybe<Scalars['String']['output']>;
  guestClassification?: Maybe<GuestClassificationModel>;
  price?: Maybe<PriceModel>;
  /** Product Id */
  productId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductTypeModel>;
  /** List of required | non required properties that must be present upon booking */
  properties?: Maybe<Array<Maybe<ProductPropertyModel>>>;
  /** Available sales locations */
  salesLocations?: Maybe<Array<Maybe<SalesLocationModel>>>;
  sourceSystemProduct?: Maybe<SourceSystemProductModel>;
  type: Scalars['JSON']['output'];
};

export type ProductPriceModel = {
  __typename?: 'ProductPriceModel';
  /** Channel Id */
  channelId?: Maybe<Scalars['Int']['output']>;
  /** Discount percentage applied to the ItemPrice */
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  /** Fixed price (overrides ItemPrice) if available */
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  /** Unit price for product */
  itemPrice?: Maybe<Scalars['Float']['output']>;
  /** Price with discounts applied */
  price?: Maybe<Scalars['Float']['output']>;
  /** Id of the product */
  productId?: Maybe<Scalars['String']['output']>;
  /** Sales location Id */
  salesLocationId?: Maybe<Scalars['Int']['output']>;
};

export type ProductPropertyModel = {
  __typename?: 'ProductPropertyModel';
  /** Data type of the property */
  dataType?: Maybe<Scalars['String']['output']>;
  /** If true, this property must be present at the time of booking the product */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the property */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductTypeModel = {
  __typename?: 'ProductTypeModel';
  /** Product Type description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product Type Id */
  id?: Maybe<Scalars['Int']['output']>;
  /** If true, product is an accomodation type product */
  isAccomodation?: Maybe<Scalars['Boolean']['output']>;
  /** If true, product is an activity type product */
  isActivity?: Maybe<Scalars['Boolean']['output']>;
  /** If true, product is a retail item type product */
  isItem?: Maybe<Scalars['Boolean']['output']>;
  /** Product Type name */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductsPriceByProductIdBySalesLocationIdResponse = HttpValidationProblemDetails | ProblemDetails | ProductAvailabilityModel | ProductAvailabilitySlotModel | ProductPriceModel;

export type Query = {
  __typename?: 'Query';
  Bluelagoon: BluelagoonQuery;
  Highlandbase: HighlandbaseQuery;
  TerkBooking: TerkBookingQuery;
  TerkProduct: TerkProductQuery;
};

export type RemoveBookingItemsRequestModelInput = {
  bookingId?: InputMaybe<Scalars['UUID']['input']>;
  bookingItemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type SalesLocationModel = {
  __typename?: 'SalesLocationModel';
  /** Which channel does the Sales location belong to */
  channelId?: Maybe<Scalars['Int']['output']>;
  /** Discount percentage applied to products sold through this channel/salesLocation */
  fixedDiscountPercentage?: Maybe<Scalars['Int']['output']>;
  /** Sales location */
  location?: Maybe<Scalars['String']['output']>;
  /** Payment option for product sold through this channel/salesLocation */
  paymentOptionId?: Maybe<Scalars['Int']['output']>;
  /** Id of the sales location */
  salesLocationId?: Maybe<Scalars['Int']['output']>;
  /** Id of the source system */
  sourceSystemId?: Maybe<Scalars['Int']['output']>;
};

export type SetPromoCodeRequestModelInput = {
  bookingId?: InputMaybe<Scalars['UUID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type SingleBookingWithCustomerResponseModel = {
  __typename?: 'SingleBookingWithCustomerResponseModel';
  bookingItems?: Maybe<Array<Maybe<BookingItemResponseModel>>>;
  bookingRef?: Maybe<Scalars['String']['output']>;
  bookingType?: Maybe<BookingType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<CustomerResponseModel>;
  error?: Maybe<Scalars['String']['output']>;
  /** Total amount to be paid using GiftCards */
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  giftCards?: Maybe<Array<Maybe<BookingGiftCardResponseModel>>>;
  id?: Maybe<Scalars['UUID']['output']>;
  paymentRequired?: Maybe<Scalars['Boolean']['output']>;
  paymentStatus?: Maybe<PaymentStateEnum>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BookingState>;
  toBePaid?: Maybe<Scalars['Float']['output']>;
  totalDiscountedPrice?: Maybe<Scalars['Float']['output']>;
  /** Total price of booking */
  totalPrice?: Maybe<Scalars['Float']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type SourceSystemDetailsModel = {
  __typename?: 'SourceSystemDetailsModel';
  /** Company guid identifier of source system, relevant for BC source systems */
  sourceSystemGuid?: Maybe<Scalars['String']['output']>;
  /** Primary identifier of source system */
  sourceSystemId?: Maybe<Scalars['String']['output']>;
  /** Company name of source system, relevant for BC source systems */
  sourceSystemName?: Maybe<Scalars['String']['output']>;
  /**
   * Secondary identifier of source system
   * Used for internal identification of source system
   */
  sourceSystemShortId?: Maybe<Scalars['String']['output']>;
  /** Type of the source system */
  sourceSystemType?: Maybe<Scalars['String']['output']>;
};

export type SourceSystemProductModel = {
  __typename?: 'SourceSystemProductModel';
  sourceSystemDetails?: Maybe<SourceSystemDetailsModel>;
  /** Product Id as seen in source system */
  sourceSystemProductId?: Maybe<Scalars['String']['output']>;
  /**
   * Product type details as seen in source system
   * For BC.Activity this is the "Fixed Location" property
   * For BC.Hotel this is the hotel name property, i.e. SILICA | RETREAT | etc
   */
  sourceSystemProductType?: Maybe<Scalars['String']['output']>;
};

export type StaffTicketsStaffTicketSetupModel = {
  __typename?: 'StaffTicketsStaffTicketSetupModel';
  availableTickets?: Maybe<Scalars['Int']['output']>;
  availableTicketsChildrenPerAdult?: Maybe<Scalars['Int']['output']>;
  availableTicketsDaily?: Maybe<Scalars['Int']['output']>;
  availableTicketsMaxPerBooking?: Maybe<Scalars['Int']['output']>;
};

export type TdsmInfo = {
  __typename?: 'TdsmInfo';
  tdsmContent?: Maybe<Scalars['String']['output']>;
};

export type TerkBookingMutation = {
  __typename?: 'TerkBookingMutation';
  deleteBookingGiftCard?: Maybe<DeleteBookingGiftCardResponse>;
  deleteBookingItems?: Maybe<DeleteBookingItemsResponse>;
  deleteMyBookingBooking?: Maybe<DeleteMyBookingBookingResponse>;
  deleteSingleBookingGiftCard?: Maybe<SingleBookingWithCustomerResponseModel>;
  deleteSingleBookingItems?: Maybe<SingleBookingWithCustomerResponseModel>;
  patchBookingItemState?: Maybe<Scalars['JSON']['output']>;
  patchBookingItemStateLink?: Maybe<Scalars['JSON']['output']>;
  patchBookingState?: Maybe<Scalars['JSON']['output']>;
  patchBookingStateLink?: Maybe<Scalars['JSON']['output']>;
  patchBookingStatePromoCode?: Maybe<Scalars['JSON']['output']>;
  postBookingCheckout?: Maybe<PostBookingCheckoutResponse>;
  postBookingCustomer?: Maybe<PostBookingCustomerResponse>;
  postBookingGiftCard?: Maybe<PostBookingGiftCardResponse>;
  postBookingItems?: Maybe<PostBookingItemsResponse>;
  postBookingNew?: Maybe<PostBookingNewResponse>;
  postBookingPromoCode?: Maybe<PostBookingPromoCodeResponse>;
  postBookingTransaction?: Maybe<PostBookingTransactionResponse>;
  postMyBookingLogin?: Maybe<PostMyBookingLoginResponse>;
  postSingleBookingCheckout?: Maybe<SingleBookingWithCustomerResponseModel>;
  postSingleBookingCustomer?: Maybe<SingleBookingWithCustomerResponseModel>;
  postSingleBookingGiftCard?: Maybe<SingleBookingWithCustomerResponseModel>;
  postSingleBookingItems?: Maybe<SingleBookingWithCustomerResponseModel>;
  postSingleBookingNew?: Maybe<SingleBookingWithCustomerResponseModel>;
  postSingleBookingPromoCode?: Maybe<SingleBookingWithCustomerResponseModel>;
  postSingleBookingTransaction?: Maybe<CreateTransactionSingleResponseModel>;
};


export type TerkBookingMutationDeleteBookingGiftCardArgs = {
  input?: InputMaybe<GiftCardRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationDeleteBookingItemsArgs = {
  input?: InputMaybe<RemoveBookingItemsRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationDeleteSingleBookingGiftCardArgs = {
  input?: InputMaybe<GiftCardRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationDeleteSingleBookingItemsArgs = {
  input?: InputMaybe<RemoveBookingItemsRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPatchBookingItemStateArgs = {
  input?: InputMaybe<BookingItemStateUpdateRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPatchBookingItemStateLinkArgs = {
  input?: InputMaybe<BookingItemStateLinkRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPatchBookingStateArgs = {
  input?: InputMaybe<BookingStateUpdateRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPatchBookingStateLinkArgs = {
  input?: InputMaybe<BookingStateLinkRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPatchBookingStatePromoCodeArgs = {
  input?: InputMaybe<BookingStatePromoCodeRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingCheckoutArgs = {
  input?: InputMaybe<CheckoutBookingRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingCustomerArgs = {
  input?: InputMaybe<BookingCustomerRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingGiftCardArgs = {
  input?: InputMaybe<GiftCardRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingItemsArgs = {
  input?: InputMaybe<AddBookingItemsRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingNewArgs = {
  input?: InputMaybe<NewBookingRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingPromoCodeArgs = {
  input?: InputMaybe<SetPromoCodeRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostBookingTransactionArgs = {
  input?: InputMaybe<CreateTransactionRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostMyBookingLoginArgs = {
  input?: InputMaybe<MyBookingRequestModelInput>;
};


export type TerkBookingMutationPostSingleBookingCheckoutArgs = {
  input?: InputMaybe<CheckoutSingleBookingRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostSingleBookingCustomerArgs = {
  input?: InputMaybe<BookingCustomerSingleBookingRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostSingleBookingGiftCardArgs = {
  input?: InputMaybe<GiftCardRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostSingleBookingItemsArgs = {
  input?: InputMaybe<AddBookingItemsRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostSingleBookingNewArgs = {
  input?: InputMaybe<NewSingleBookingRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostSingleBookingPromoCodeArgs = {
  input?: InputMaybe<SetPromoCodeRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingMutationPostSingleBookingTransactionArgs = {
  input?: InputMaybe<CreateSingleBookingTransactionRequestModelInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};

export type TerkBookingQuery = {
  __typename?: 'TerkBookingQuery';
  _?: Maybe<Scalars['JSON']['output']>;
  bookingById?: Maybe<BookingByIdResponse>;
  singleBookingById?: Maybe<SingleBookingWithCustomerResponseModel>;
};


export type TerkBookingQueryBookingByIdArgs = {
  id: Scalars['UUID']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkBookingQuerySingleBookingByIdArgs = {
  id: Scalars['UUID']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};

export type TerkProductQuery = {
  __typename?: 'TerkProductQuery';
  _?: Maybe<Scalars['JSON']['output']>;
  /** Fetch Product Availability, lists details regarding pricing and availability */
  postProductsAvailability?: Maybe<Array<Maybe<ProductAvailabilityModel>>>;
  /** Fetch Product Availability for single timeslot */
  postProductsAvailabilitySlot?: Maybe<PostProductsAvailabilitySlotResponse>;
  /** Fetch Product Availability, only returns whether there is availability for the given timeslots */
  postProductsAvailable?: Maybe<Array<Maybe<PostProductsAvailableResponse>>>;
  /** List all products. */
  products?: Maybe<Array<Maybe<ProductModel>>>;
  /** Get price of retail item */
  productsPriceByProductIdBySalesLocationId?: Maybe<ProductsPriceByProductIdBySalesLocationIdResponse>;
  /** List all products. */
  sourceRefreshCache?: Maybe<Scalars['Void']['output']>;
  sourceSourceSystems?: Maybe<Array<Maybe<SourceSystemDetailsModel>>>;
};


export type TerkProductQueryPostProductsAvailabilityArgs = {
  channel: Scalars['Int']['input'];
  input?: InputMaybe<PostProductsAvailabilityRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkProductQueryPostProductsAvailabilitySlotArgs = {
  channel: Scalars['Int']['input'];
  input?: InputMaybe<PostProductsAvailabilitySlotRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkProductQueryPostProductsAvailableArgs = {
  channel: Scalars['Int']['input'];
  input?: InputMaybe<PostProductsAvailableRequestInput>;
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkProductQueryProductsArgs = {
  channel: Scalars['Int']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkProductQueryProductsPriceByProductIdBySalesLocationIdArgs = {
  channel: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  salesLocationId: Scalars['Int']['input'];
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkProductQuerySourceRefreshCacheArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type TerkProductQuerySourceSourceSystemsArgs = {
  xApiKey?: InputMaybe<Scalars['String']['input']>;
};

export type VoidContainer = {
  __typename?: 'VoidContainer';
  void?: Maybe<Scalars['Void']['output']>;
};

export type GiftCardFragmentFragment = { __typename?: 'GiftCardGetGiftCardResponse', number?: string | null, status?: string | null, validTo?: string | null, externalDocumentNo?: string | null, amount?: number | null } & { ' $fragmentName'?: 'GiftCardFragmentFragment' };

export type FindGiftcardQueryMutationVariables = Exact<{
  input: BookingFlowFindGiftCardRequestModelInput;
}>;


export type FindGiftcardQueryMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerGiftcardFind?: (
        { __typename?: 'GiftCardGetGiftCardResponse' }
        & { ' $fragmentRefs'?: { 'GiftCardFragmentFragment': GiftCardFragmentFragment } }
      ) | null } } };

export type FindGiftCardExternalDocumentMutationVariables = Exact<{
  input: BookingFlowFindGiftCardRequestModelInput;
}>;


export type FindGiftCardExternalDocumentMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerGiftcardFind?: { __typename?: 'GiftCardGetGiftCardResponse', externalDocumentNo?: string | null } | null } } };

export type BlGetGiftCardMutationVariables = Exact<{
  input: BookingFlowFindGiftCardRequestModelInput;
}>;


export type BlGetGiftCardMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerGiftcardFind?: { __typename?: 'GiftCardGetGiftCardResponse', amount?: number | null, number?: string | null, externalDocumentNo?: string | null, customerName?: string | null, customerEmail?: string | null, message?: string | null, shippingMethod?: string | null, status?: string | null, recipientName?: string | null, recipientAddress?: string | null, recipientPostCode?: string | null } | null } } };

export type BlGetTransactionStatusQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type BlGetTransactionStatusQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', paymentTransactionStatusBySearch?: { __typename?: 'MicrosoftAspNetCoreMvcProblemDetails' } | { __typename?: 'PaymentPlanetGetPaymentStatusResponse', data?: Array<{ __typename?: 'PaymentPlanetPaymentStatus', refNo?: string | null, data?: { __typename?: 'PaymentPlanetPaymentStatusModel', status?: string | null, refNo?: string | null, transactionId?: string | null, detail?: { __typename?: 'PaymentPlanetPaymentDetailModel', fail?: { __typename?: 'PaymentPlanetPaymentDetailFailModel', message?: string | null } | null } | null } | null } | null> | null } | null } } };

export type BlCreateGiftCardMutationVariables = Exact<{
  input: BookingFlowGiftCardOrderModelInput;
}>;


export type BlCreateGiftCardMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerGiftcardCreate?: { __typename?: 'GiftCardCreateGiftCardResponse', giftCardNo?: string | null } | null } } };

export type BlFinalizeGiftCardMutationVariables = Exact<{
  info: BookingFlowFinalizeGiftCardModelInput;
}>;


export type BlFinalizeGiftCardMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerGiftcardFinalize?: { __typename?: 'GiftCardFinalizeGiftCardResponse', giftCard?: { __typename?: 'BookingFlowGiftCardOrderModel', externalDocNo?: string | null } | null } | null } } };

export type InWaterAvailabilityQueryVariables = Exact<{
  input: BookingFlowGetProductAvailabilityRequestModelInput;
}>;


export type InWaterAvailabilityQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', postCartDayspaProductAvailability?: { __typename?: 'BookingFlowCartGetProductAvailabilityResponse', offer?: Array<{ __typename?: 'BookingFlowCartProductOfferData', offerId?: number | null, time?: string | null, available?: number | null, productId?: string | null, price?: number | null } | null> | null } | null } } };

export type RestaurantAvailabilityBlQueryVariables = Exact<{
  input: BookingFlowGetProductAvailabilityRequestModelInput;
}>;


export type RestaurantAvailabilityBlQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', postCartDayspaProductAvailability?: { __typename?: 'BookingFlowCartGetProductAvailabilityResponse', offer?: Array<{ __typename?: 'BookingFlowCartProductOfferData', productId?: string | null, time?: string | null, available?: number | null, offerId?: number | null } | null> | null } | null } } };

export type RoomRangeAvailabilityCalendarQueryVariables = Exact<{
  input: HotelCartRoomUnavailabilityRangeModelInput;
}>;


export type RoomRangeAvailabilityCalendarQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', postCartHotelRangeAvailabilityCalendar?: { __typename?: 'HotelCartHotelUnavailabilityRangeResponse', checkoutOnlyDays: Array<string | null>, disabledDays: Array<string | null>, firstAvailableDateRange?: { __typename?: 'HotelCartHotelAvailableDateRange', from?: string | null, to?: string | null } | null } | null } } };

export type NewCartMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type NewCartMutationMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartHotelNew?: { __typename?: 'HotelCartDtoHotelCartData', id?: string | null } | null } } };

export type AddToCartMutationMutationVariables = Exact<{
  input: BookingFlowCartAddItemRequestModelInput;
}>;


export type AddToCartMutationMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartHotelAdd?: { __typename?: 'HotelCartDtoHotelCartData', id?: string | null, items?: Array<{ __typename?: 'HotelCartDtoHotelCartItemData', id?: string | null, fullName?: string | null, price?: number | null, meta?: Record<string, any> | null } | null> | null } | null } } };

export type RoomAvailabilityQueryVariables = Exact<{
  input: HotelCartRoomAvailabilityModelInput;
}>;


export type RoomAvailabilityQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', postCartHotelRoomAvailability?: { __typename?: 'HotelCartHotelAvailabilityResponse', availability?: Array<{ __typename?: 'HotelCartDtoHotelRoomTypeAvailability', productId?: string | null, available?: number | null, rateCodes?: Record<string, any> | null } | null> | null } | null } } };

export type BlCreateNewSpaCartMutationVariables = Exact<{ [key: string]: never; }>;


export type BlCreateNewSpaCartMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaNew?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null } | null } } };

export type BlAddToCartMutationVariables = Exact<{
  input: BookingFlowCartAddItemRequestModelInput;
}>;


export type BlAddToCartMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaAdd?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null } | null } } };

export type BlRemoveItemFromCartMutationVariables = Exact<{
  cartId: Scalars['UUID']['input'];
  itemId: Scalars['String']['input'];
}>;


export type BlRemoveItemFromCartMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaRemove?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null } | null } } };

export type BlAddMembershipTokenMutationVariables = Exact<{
  input: BookingFlowCartAddMembershipTokenRequestModelInput;
}>;


export type BlAddMembershipTokenMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaAddMembershipToken?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null, membership?: { __typename?: 'BookingFlowCartDtoMembershipInfo', membershipToken?: string | null, type?: string | null, subType?: string | null } | null } | null } } };

export type BlAddCustomerInfoMutationVariables = Exact<{
  input: BookingFlowCartStoreCustomerModelInput;
}>;


export type BlAddCustomerInfoMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaCustomer?: { __typename: 'BookingFlowCartBookingFlowCartStoreCustomerResponse', cart?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null } | null } | null } } };

export type BlSpaExtraAvailabilityFragment = { __typename?: 'BookingFlowCartGetProductAvailabilityResponse', offer?: Array<{ __typename?: 'BookingFlowCartProductOfferData', offerId?: number | null, time?: string | null, available?: number | null, productId?: string | null, price?: number | null } | null> | null } & { ' $fragmentName'?: 'BlSpaExtraAvailabilityFragment' };

export type BlProductAvailabilityQueryVariables = Exact<{
  input: BookingFlowGetProductAvailabilityRequestModelInput;
}>;


export type BlProductAvailabilityQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', postCartDayspaProductAvailability?: (
        { __typename: 'BookingFlowCartGetProductAvailabilityResponse' }
        & { ' $fragmentRefs'?: { 'BlSpaTimeSlotAvailabilityFragment': BlSpaTimeSlotAvailabilityFragment;'BlSpaExtraAvailabilityFragment': BlSpaExtraAvailabilityFragment } }
      ) | null } } };

export type BlSpaProductCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type BlSpaProductCatalogQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', cartDayspaProducts?: { __typename?: 'ProductCatalogGetProductsResponse', products?: Array<{ __typename?: 'ProductCatalogDtoProductData', productId?: string | null, price?: number | null, discountedPrice?: number | null, fixedDiscountPercentage?: number | null, timeSlotLength?: number | null } | null> | null } | null } } };

export type BlGetSpaCartQueryVariables = Exact<{
  cartId: Scalars['UUID']['input'];
}>;


export type BlGetSpaCartQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', cartDayspaById?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null, paymentAmount?: number | null, paymentRequired?: boolean | null, promoCode?: string | null, giftCardAmount?: number | null, discountedAmount?: number | null, giftCards?: Array<{ __typename?: 'BookingFlowCartSpaGiftCardModel', no?: string | null, balance?: number | null, chargeAmount?: number | null } | null> | null, customer?: { __typename?: 'BookingFlowCartSpaCartCustomerModel', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, nationality?: string | null, newsletter?: boolean | null } | null, membership?: { __typename?: 'BookingFlowCartDtoMembershipInfo', membershipToken?: string | null, type?: string | null, subType?: string | null, numberOfCardHolders?: number | null } | null, items?: Array<{ __typename?: 'BookingFlowCartSpaCartItemDataModel', id?: number | null, productId?: string | null, qty?: number | null, fullName?: string | null, price?: number | null, totalLinePrice?: number | null, linePrice?: number | null, discountedPrice?: number | null, type?: string | null, meta?: Record<string, any> | null } | null> | null } | null } } };

export type BlLoginWithBookingRefMutationVariables = Exact<{
  email: Scalars['String']['input'];
  bookingRef: Scalars['String']['input'];
}>;


export type BlLoginWithBookingRefMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postMybookingLogin?: { __typename?: 'BlBookingApiSecurityModelsJwtTokenResult', token?: string | null, refreshToken?: string | null, _error?: { __typename?: 'ErrorObject', errorCode?: string | null, errorMessage?: string | null } | null } | null } } };

export type BlSpaBookingQueryVariables = Exact<{ [key: string]: never; }>;


export type BlSpaBookingQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', mybookingBooking?: { __typename?: 'MyBookingMyBookingInfoModel', bookingId?: string | null, arrivalTime?: string | null, adultCount?: number | null, teenagerCount?: number | null, childrenCount?: number | null, packageType?: string | null, products?: Array<{ __typename?: 'MyBookingMyBookingAddedProductData', productId?: string | null, qty?: number | null } | null> | null, customer?: { __typename?: 'MyBookingMyBookingCustomerData', email?: string | null } | null } | null } } };

export type BlSpaBookingActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type BlSpaBookingActivitiesQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', mybookingActivities?: { __typename?: 'MyBookingGetActivityLinesResponse', activityLines?: Array<{ __typename?: 'BcActivityLine', numberOfPersons?: number | null, numberOfAdults?: number | null, numberOfChildren?: number | null, quantity?: number | null, productNo?: string | null, reservationDate?: string | null, comment?: string | null, data?: Record<string, any> | null } | null> | null } | null } } };

export type CheckoutTransactionMutationVariables = Exact<{
  input: BookingFlowCartConfirmModelInput;
}>;


export type CheckoutTransactionMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaCheckout?: { __typename?: 'BookingFlowCartBookingFlowCartCheckoutResponse', bookingNumber?: string | null, _error?: { __typename?: 'ErrorObject', errorCode?: string | null, errorMessage?: string | null } | null } | null } } };

export type BlSpaTimeSlotAvailabilityFragment = { __typename?: 'BookingFlowCartGetProductAvailabilityResponse', offer?: Array<{ __typename?: 'BookingFlowCartProductOfferData', offerId?: number | null, productId?: string | null, time?: string | null, available?: number | null, price?: number | null } | null> | null } & { ' $fragmentName'?: 'BlSpaTimeSlotAvailabilityFragment' };

export type BlCustomerInfoMutationVariables = Exact<{
  input: BookingFlowCartStoreCustomerModelInput;
}>;


export type BlCustomerInfoMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaCustomer?: { __typename: 'BookingFlowCartBookingFlowCartStoreCustomerResponse', cart?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null } | null } | null } } };

export type BlAddGiftCardMutationVariables = Exact<{
  input: BookingFlowCartAddGiftCardRequestModelInput;
}>;


export type BlAddGiftCardMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaAddGiftCard?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null, giftCards?: Array<{ __typename?: 'BookingFlowCartSpaGiftCardModel', no?: string | null, balance?: number | null, chargeAmount?: number | null } | null> | null } | null } } };

export type BlRemoveGiftCardMutationVariables = Exact<{
  input: BookingFlowCartRemoveGiftCardRequestModelInput;
}>;


export type BlRemoveGiftCardMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaRemoveGiftCard?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null, giftCards?: Array<{ __typename?: 'BookingFlowCartSpaGiftCardModel', no?: string | null, balance?: number | null, chargeAmount?: number | null } | null> | null } | null } } };

export type HbAddPromoCodeMutationVariables = Exact<{
  input: BookingFlowCartAddPromoCodeRequestModelInput;
}>;


export type HbAddPromoCodeMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaAddPromoCode?: { __typename?: 'BookingFlowCartSpaCartDataModel', id?: string | null, promoCode?: string | null } | null } } };

export type BlRequestMembershipSmsMutationVariables = Exact<{
  input?: InputMaybe<BookingFlowRequestMembershipCardSmsCodeModelInput>;
}>;


export type BlRequestMembershipSmsMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerMembershipRequestSms?: Record<string, any> | null } } };

export type BlMembershipValidateSmsMutationVariables = Exact<{
  input: BookingFlowValidateMembershipCardModelInput;
}>;


export type BlMembershipValidateSmsMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postBookingflowServerMembershipValidateSms?: { __typename?: 'MembershipValidateMembershipSmsCodeResponse', type?: string | null, name?: string | null, validFrom?: string | null, validTo?: string | null, userName?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, numberOfCardHolders?: number | null, membershipValidationToken?: string | null } | null } } };

export type StartTransactionMutationVariables = Exact<{
  input?: InputMaybe<BookingFlowCartTransactionModelInput>;
}>;


export type StartTransactionMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postCartDayspaTransaction?: { __typename?: 'BookingFlowCartBookingFlowCartTransactionResponse', paymentId?: number | null, transactionId?: string | null, _error?: { __typename?: 'ErrorObject', errorCode?: string | null, errorMessage?: string | null } | null } | null } } };

export type BlSpaTransportationOfferFragment = { __typename?: 'BookingFlowCartGetProductAvailabilityResponse', offer?: Array<{ __typename?: 'BookingFlowCartProductOfferData', offerId?: number | null, productId?: string | null, time?: string | null, available?: number | null, price?: number | null, componentType?: string | null, componentId?: string | null, subOffers?: Array<{ __typename?: 'BookingFlowCartProductSubOfferData', additionalInfo?: Record<string, any> | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'BlSpaTransportationOfferFragment' };

export type BlSpaTransportationAvailabilityQueryVariables = Exact<{
  input: BookingFlowGetProductAvailabilityRequestModelInput;
}>;


export type BlSpaTransportationAvailabilityQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', postCartDayspaProductAvailability?: (
        { __typename?: 'BookingFlowCartGetProductAvailabilityResponse' }
        & { ' $fragmentRefs'?: { 'BlSpaTransportationOfferFragment': BlSpaTransportationOfferFragment } }
      ) | null } } };

export type BlTransferLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlTransferLocationsQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', cartDayspaTransferLocations?: { __typename?: 'ProductCatalogGetTransportLocationsResponse', locations?: Array<{ __typename?: 'ProductCatalogLocation', locationId?: number | null, componentId?: number | null, type?: ProductCatalogLocationType | null, name?: string | null, address?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null } | null> | null } | null } } };

export type InitMembershipTransactionMutationVariables = Exact<{
  input: BookingFlowOrderMembershipTransactionModelInput;
}>;


export type InitMembershipTransactionMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postMembershipTransactionInit?: { __typename?: 'MembershipMembershipInitTransactionResponse', transactionId?: string | null, membershipId?: number | null, paymentTransactionId?: number | null } | null } } };

export type FinalizeMembershipTransactionMutationVariables = Exact<{
  input: BookingFlowOrderMembershipFinalizeTransactionModelInput;
}>;


export type FinalizeMembershipTransactionMutation = { __typename?: 'Mutation', Bluelagoon: { __typename?: 'BluelagoonMutation', Booking: { __typename?: 'BookingMutation', postMembershipTransactionFinalize?: { __typename?: 'MembershipMembershipFinalizePaymentResponse', authorizationCode?: string | null, transactionId?: string | null, cardHolder?: { __typename?: 'MembershipsContactData', id?: string | null, firstName?: string | null, lastName?: string | null, personalId?: string | null, email?: string | null, phoneNumber?: string | null } | null } | null } } };

export type InRoomProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type InRoomProductsQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', cartHotelProducts?: { __typename?: 'ProductCatalogGetProductsResponse', products?: Array<{ __typename?: 'ProductCatalogDtoProductData', productId?: string | null, price?: number | null, displayName?: string | null } | null> | null } | null } } };

export type ConversionRatesFragment = { __typename?: 'PaymentPlanetCurrencyConversionRate', currency?: string | null, value?: number | null } & { ' $fragmentName'?: 'ConversionRatesFragment' };

export type ErrorFragmentFragment = { __typename?: 'MicrosoftAspNetCoreMvcProblemDetails', title?: string | null, status?: number | null, detail?: string | null, type?: string | null, instance?: string | null } & { ' $fragmentName'?: 'ErrorFragmentFragment' };

export type GetCurrencyRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyRatesQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', paymentCurrencyRates?: (
        { __typename?: 'MicrosoftAspNetCoreMvcProblemDetails' }
        & { ' $fragmentRefs'?: { 'ErrorFragmentFragment': ErrorFragmentFragment } }
      ) | { __typename?: 'PaymentPlanetCollectCurrencyConversionRatesResponse', conversionRates?: { __typename?: 'PaymentPlanetCurrencyConversion', rates?: Array<(
            { __typename?: 'PaymentPlanetCurrencyConversionRate' }
            & { ' $fragmentRefs'?: { 'ConversionRatesFragment': ConversionRatesFragment } }
          ) | null> | null } | null } | null, paymentMulticurrencyRates?: (
        { __typename?: 'MicrosoftAspNetCoreMvcProblemDetails' }
        & { ' $fragmentRefs'?: { 'ErrorFragmentFragment': ErrorFragmentFragment } }
      ) | { __typename?: 'PaymentPlanetCollectCurrencyConversionRatesResponse', conversionRates?: { __typename?: 'PaymentPlanetCurrencyConversion', reportDetail?: { __typename?: 'PaymentPlanetCurrencyConversionDetail', retrievalReferenceNumber?: string | null } | null, rates?: Array<(
            { __typename?: 'PaymentPlanetCurrencyConversionRate' }
            & { ' $fragmentRefs'?: { 'ConversionRatesFragment': ConversionRatesFragment } }
          ) | null> | null } | null } | null } } };

export type RestrictionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RestrictionsQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', cartHotelRestrictions?: { __typename?: 'HotelCartHotelRestrictionsResponse', rateCodeRestriction?: Record<string, any> | null, roomTypeRestriction?: Record<string, any> | null, propertyRestriction?: Record<string, any> | null } | null } } };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', Bluelagoon: { __typename?: 'BluelagoonQuery', Booking: { __typename?: 'BookingQuery', cartHotelProducts?: { __typename?: 'ProductCatalogGetProductsResponse', products?: Array<{ __typename?: 'ProductCatalogDtoProductData', productId?: string | null, price?: number | null, displayName?: string | null, fixedDiscountPercentage?: number | null, discountedPrice?: number | null, productType?: string | null } | null> | null } | null } } };

export const GiftCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GiftCardGetGiftCardResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentNo"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<GiftCardFragmentFragment, unknown>;
export const BlSpaExtraAvailabilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BLSpaExtraAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartGetProductAvailabilityResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<BlSpaExtraAvailabilityFragment, unknown>;
export const BlSpaTimeSlotAvailabilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BLSpaTimeSlotAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartGetProductAvailabilityResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<BlSpaTimeSlotAvailabilityFragment, unknown>;
export const BlSpaTransportationOfferFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BLSpaTransportationOffer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartGetProductAvailabilityResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"componentType"}},{"kind":"Field","name":{"kind":"Name","value":"componentId"}},{"kind":"Field","name":{"kind":"Name","value":"subOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}}]}}]}}]}}]} as unknown as DocumentNode<BlSpaTransportationOfferFragment, unknown>;
export const ConversionRatesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionRates"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPlanetCurrencyConversionRate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<ConversionRatesFragment, unknown>;
export const ErrorFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MicrosoftAspNetCoreMvcProblemDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"instance"}}]}}]} as unknown as DocumentNode<ErrorFragmentFragment, unknown>;
export const FindGiftcardQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"findGiftcardQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowFindGiftCardRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerGiftcardFind"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCardFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GiftCardGetGiftCardResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentNo"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<FindGiftcardQueryMutation, FindGiftcardQueryMutationVariables>;
export const FindGiftCardExternalDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FindGiftCardExternalDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowFindGiftCardRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerGiftcardFind"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalDocumentNo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindGiftCardExternalDocumentMutation, FindGiftCardExternalDocumentMutationVariables>;
export const BlGetGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLGetGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowFindGiftCardRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerGiftcardFind"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"externalDocumentNo"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAddress"}},{"kind":"Field","name":{"kind":"Name","value":"recipientPostCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlGetGiftCardMutation, BlGetGiftCardMutationVariables>;
export const BlGetTransactionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLGetTransactionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentTransactionStatusBySearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPlanetGetPaymentStatusResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refNo"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"refNo"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlGetTransactionStatusQuery, BlGetTransactionStatusQueryVariables>;
export const BlCreateGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLCreateGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowGiftCardOrderModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerGiftcardCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"giftCardNo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlCreateGiftCardMutation, BlCreateGiftCardMutationVariables>;
export const BlFinalizeGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLFinalizeGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"info"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowFinalizeGiftCardModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerGiftcardFinalize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"info"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalDocNo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlFinalizeGiftCardMutation, BlFinalizeGiftCardMutationVariables>;
export const InWaterAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InWaterAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowGetProductAvailabilityRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaProductAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InWaterAvailabilityQuery, InWaterAvailabilityQueryVariables>;
export const RestaurantAvailabilityBlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RestaurantAvailabilityBL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowGetProductAvailabilityRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaProductAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"offerId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestaurantAvailabilityBlQuery, RestaurantAvailabilityBlQueryVariables>;
export const RoomRangeAvailabilityCalendarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoomRangeAvailabilityCalendar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HotelCartRoomUnavailabilityRangeModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartHotelRangeAvailabilityCalendar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutOnlyDays"}},{"kind":"Field","name":{"kind":"Name","value":"disabledDays"}},{"kind":"Field","name":{"kind":"Name","value":"firstAvailableDateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomRangeAvailabilityCalendarQuery, RoomRangeAvailabilityCalendarQueryVariables>;
export const NewCartMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewCartMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartHotelNew"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewCartMutationMutation, NewCartMutationMutationVariables>;
export const AddToCartMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToCartMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartAddItemRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartHotelAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddToCartMutationMutation, AddToCartMutationMutationVariables>;
export const RoomAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoomAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HotelCartRoomAvailabilityModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartHotelRoomAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"rateCodes"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoomAvailabilityQuery, RoomAvailabilityQueryVariables>;
export const BlCreateNewSpaCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLCreateNewSpaCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaNew"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlCreateNewSpaCartMutation, BlCreateNewSpaCartMutationVariables>;
export const BlAddToCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLAddToCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartAddItemRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlAddToCartMutation, BlAddToCartMutationVariables>;
export const BlRemoveItemFromCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLRemoveItemFromCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cartId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlRemoveItemFromCartMutation, BlRemoveItemFromCartMutationVariables>;
export const BlAddMembershipTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLAddMembershipToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartAddMembershipTokenRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaAddMembershipToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipToken"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlAddMembershipTokenMutation, BlAddMembershipTokenMutationVariables>;
export const BlAddCustomerInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLAddCustomerInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartStoreCustomerModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlAddCustomerInfoMutation, BlAddCustomerInfoMutationVariables>;
export const BlProductAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLProductAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowGetProductAvailabilityRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaProductAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BLSpaTimeSlotAvailability"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BLSpaExtraAvailability"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BLSpaTimeSlotAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartGetProductAvailabilityResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BLSpaExtraAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartGetProductAvailabilityResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<BlProductAvailabilityQuery, BlProductAvailabilityQueryVariables>;
export const BlSpaProductCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLSpaProductCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartDayspaProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"fixedDiscountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"timeSlotLength"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlSpaProductCatalogQuery, BlSpaProductCatalogQueryVariables>;
export const BlGetSpaCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLGetSpaCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartDayspaById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"giftCardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"giftCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"no"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipToken"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCardHolders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"totalLinePrice"}},{"kind":"Field","name":{"kind":"Name","value":"linePrice"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlGetSpaCartQuery, BlGetSpaCartQueryVariables>;
export const BlLoginWithBookingRefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLLoginWithBookingRef"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postMybookingLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bookingRef"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingRef"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"_error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlLoginWithBookingRefMutation, BlLoginWithBookingRefMutationVariables>;
export const BlSpaBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLSpaBooking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mybookingBooking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingId"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"adultCount"}},{"kind":"Field","name":{"kind":"Name","value":"teenagerCount"}},{"kind":"Field","name":{"kind":"Name","value":"childrenCount"}},{"kind":"Field","name":{"kind":"Name","value":"packageType"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlSpaBookingQuery, BlSpaBookingQueryVariables>;
export const BlSpaBookingActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLSpaBookingActivities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mybookingActivities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfPersons"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAdults"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfChildren"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"productNo"}},{"kind":"Field","name":{"kind":"Name","value":"reservationDate"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlSpaBookingActivitiesQuery, BlSpaBookingActivitiesQueryVariables>;
export const CheckoutTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartConfirmModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"_error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckoutTransactionMutation, CheckoutTransactionMutationVariables>;
export const BlCustomerInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLCustomerInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartStoreCustomerModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlCustomerInfoMutation, BlCustomerInfoMutationVariables>;
export const BlAddGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLAddGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartAddGiftCardRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaAddGiftCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"giftCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"no"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlAddGiftCardMutation, BlAddGiftCardMutationVariables>;
export const BlRemoveGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLRemoveGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartRemoveGiftCardRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaRemoveGiftCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"giftCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"no"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlRemoveGiftCardMutation, BlRemoveGiftCardMutationVariables>;
export const HbAddPromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HBAddPromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartAddPromoCodeRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaAddPromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HbAddPromoCodeMutation, HbAddPromoCodeMutationVariables>;
export const BlRequestMembershipSmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLRequestMembershipSms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowRequestMembershipCardSmsCodeModelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerMembershipRequestSms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]}}]}}]} as unknown as DocumentNode<BlRequestMembershipSmsMutation, BlRequestMembershipSmsMutationVariables>;
export const BlMembershipValidateSmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BLMembershipValidateSms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowValidateMembershipCardModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postBookingflowServerMembershipValidateSms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCardHolders"}},{"kind":"Field","name":{"kind":"Name","value":"membershipValidationToken"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlMembershipValidateSmsMutation, BlMembershipValidateSmsMutationVariables>;
export const StartTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartTransactionModelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"_error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StartTransactionMutation, StartTransactionMutationVariables>;
export const BlSpaTransportationAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLSpaTransportationAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowGetProductAvailabilityRequestModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCartDayspaProductAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BLSpaTransportationOffer"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BLSpaTransportationOffer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowCartGetProductAvailabilityResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"componentType"}},{"kind":"Field","name":{"kind":"Name","value":"componentId"}},{"kind":"Field","name":{"kind":"Name","value":"subOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}}]}}]}}]}}]} as unknown as DocumentNode<BlSpaTransportationAvailabilityQuery, BlSpaTransportationAvailabilityQueryVariables>;
export const BlTransferLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BLTransferLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartDayspaTransferLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"componentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlTransferLocationsQuery, BlTransferLocationsQueryVariables>;
export const InitMembershipTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitMembershipTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowOrderMembershipTransactionModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postMembershipTransactionInit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTransactionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InitMembershipTransactionMutation, InitMembershipTransactionMutationVariables>;
export const FinalizeMembershipTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeMembershipTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingFlowOrderMembershipFinalizeTransactionModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postMembershipTransactionFinalize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizationCode"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"cardHolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"personalId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeMembershipTransactionMutation, FinalizeMembershipTransactionMutationVariables>;
export const InRoomProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InRoomProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartHotelProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InRoomProductsQuery, InRoomProductsQueryVariables>;
export const GetCurrencyRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrencyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPlanetCollectCurrencyConversionRatesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversionRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionRates"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMulticurrencyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPlanetCollectCurrencyConversionRatesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversionRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retrievalReferenceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionRates"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionRates"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPlanetCurrencyConversionRate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MicrosoftAspNetCoreMvcProblemDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"instance"}}]}}]} as unknown as DocumentNode<GetCurrencyRatesQuery, GetCurrencyRatesQueryVariables>;
export const RestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Restrictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartHotelRestrictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateCodeRestriction"}},{"kind":"Field","name":{"kind":"Name","value":"roomTypeRestriction"}},{"kind":"Field","name":{"kind":"Name","value":"propertyRestriction"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestrictionsQuery, RestrictionsQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Bluelagoon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartHotelProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fixedDiscountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;